import { TextureLoader, WebGLRenderer, Group, Scene, Raycaster, PerspectiveCamera, SphereGeometry, MeshBasicMaterial, Mesh, PlaneGeometry, RepeatWrapping, Vector3, BackSide, LoadingManager, ShaderMaterial, Audio, AudioListener, AudioLoader, Object3D, BoxGeometry, Clock, MathUtils, Color } from 'three';
import $ from 'jquery';
import { OrbitControls } from './controls/orbitControls';
import { CSS3DRenderer } from 'three/examples/jsm/renderers/CSS3DRenderer.js';

import { areSameResource, closeTinyMCEMoreMenu, degrees_to_radians, isMobile, normaliseAngle, radians_to_degrees } from './components/engine/helpers/worldHelpers';
import { imageExists } from './components/engine/helpers/api';
import { getLowResImageUrl } from './components/engine/helpers/getImageType';

import DeviceOrientationState from './controls/deviceOrientationState';

import { Circ, Back, gsap, Linear, Expo } from 'gsap';

import { VRPlaceObject } from './components/engine/VRPlaceObject';

import { get_ } from './components/MVC/loadTextures';
import { getCookie } from './components/engine/helpers/cookie';
import { SCENE_INTERACTION } from './constants/scene';
import { WEBRTC_EVENTS } from './constants/webrtc';
import { ANT_MEDIA_SERVER_BAGELSS_EVENTS } from './components/WebRTC/constants';
import { baglessRoomLockTexture, chessTexture, emptyTexture, infoTexture, musicObjectTexture, paypalDonateTexture, imageGallery, imageGalleryLoading } from './components/engine/helpers/texturesAndGeometries';
import { indicator2D } from './components/components';
import getTooltipByType from './components/engine/helpers/getTooltipByType';
import { SCENE_EVENTS } from './components/MVC/Model';
import SphereController, { SPHERE_CONTROLLER_LOADER } from './components/Controllers/SphereController';

function isVideoPlayerType(type) {
  return type === 'videoPlayer' || type === 'videoPlayerWebGL';
}
import {
  CONFIRM_NOTIFICATION_SIZE,
  CONFIRM_NOTIFICATION_THEME,
  CONFIRM_NOTIFICATION_TYPE
} from "./components/Modals/Notifications/ConfirmNotification";
import AutoRotateController from './components/engine/AutoRotateController';
import { SCENE_OBJECT_TYPES } from './constants/SceneObjects';
import { buildFullAgentConfigFromLibrary, findLibraryAgentForChair } from './constants/eventActions';
import { Postit } from './components/engine/HTMLElements/Postit';
import { VRVapiChairWithCSS3D } from './components/engine/VRVapiChairWithCSS3D';
import { VRVapiCameraWithCSS3D } from './components/engine/VRVapiCameraWithCSS3D';
import { VRVapiTranscriptionWithCSS3D } from './components/engine/VRVapiTranscriptionWithCSS3D';
import { VRVapiButtonWithCSS3D } from './components/engine/VRVapiButtonWithCSS3D';
import { VRIframeElement } from './components/engine/VRIframeElement';
import { VRTimerElement } from './components/engine/VRTimerElement';
import { VRInputFieldGuess } from './components/engine/VRInputFieldGuess';
import { VRInputField } from './components/engine/VRInputField';
import { VRLoadingScreen } from './components/engine/VRLoadingScreen';

const axios = require('axios');

const css3DContainer = document.querySelector('#css3d');
const webglCanvas = document.querySelector('#webgl');

const loadingBarElement = document.querySelector('.loading-bar');
const crosshairHolder = document.querySelector('.crosshair');
const loadingSpinnerHolder = document.querySelector('.spinner-holder');
const showRoomSlider = document.querySelector('.showRoomSlider');
const leftSidebar = document.querySelector('.leftSidebar');

class Scene3D {

  constructor({ model, preloader, URLS }) {
    if (!model) {
      console.log('No model Scene3D!');
      return;
    }
    this.historyLastLocation = null;

    // USETIFUL
    const { userId: id, userName, isGuest, role: userRole } = model.config;

    const userId = model.editMode ? URLS.userData.id : isGuest ? 'uniqueGuestID' : id;
    const role = model.editMode ? URLS.userData.role : userRole;
    const firstName = model.editMode ? URLS.userData.userName : userName;

    // Set Usetiful tags before loading script
    window.usetifulTags = { language: "en", role, firstName, mode: "prospect", plan: model?.config?.subscriptionPlan?.plan?.name, lng: multiLanguagesController.language };

    /**
     * Performance stats
     */
    // this.stats = new Stats();
    // this.stats.setMode(0);
    // this.stats.domElement.classList.add('performance-stats');
    // !model.editMode && document.querySelector('#stats_holder').appendChild(this.stats.domElement);

    /**
     * Grab world data
     */
    this.model = model;
    model.config.role = role;
    this.worldData = model.sceneData;
    this.scenes = this.worldData.scenes;

    this.urlParams = new URLSearchParams(window.location.search);
    this.worldID = this.urlParams.get('id');
    this.url = new URL(window.location.href);
    this.clock = new Clock();

    this.texturesToLoad = {};
    this.loadedTextures = {};
    this.scenes.map(item => {
      this.texturesToLoad[item.id] = item.background.mediumPath;
    });

    const { currentScene, currentSceneIndex } = this.getSceneById(this.urlParams.get('loc') || null);

    this.currentSceneIndex = currentSceneIndex;
    this.currentScene = currentScene;
    this.getDefaultBg = get_;

    this.setPublicStageStatus();

    $(".room_thumbnail").attr('src', this.worldData.previewBackgroundImage.mediumPath);
    $(".room_logo").attr('src', this.worldData.customLogo || './textures/empty.png');
    $(".room_splash").attr('src', this.worldData.splashImage || '/textures/logo.png');
    $("#worldPublicAvailable").prop('checked', this.worldData.publicAvailable);
    $("#embededPageEnabled").prop('checked', this.worldData.embedded);
    $("#tour_mode_edit").prop('checked', this.worldData.tourModeAvailable);
    $("#tour_mode_disable_autorotate_edit").prop('checked', this.worldData.disableAutorotate === 1 || this.worldData.disableAutorotate === true);
    $("#disable_postits_edit").prop('checked', this.worldData.disablePostits);
    $("#disable_chat_edit").prop('checked', this.worldData.disableChat === 1 || this.worldData.disableChat === true);
    $("#disable_user_list_edit").prop('checked', this.worldData.disableUserList === 1 || this.worldData.disableUserList === true);
    $("#draft_mode_edit").prop('checked', this.worldData.is_draft === 1);
    $("#disable_guest_restrictions_edit").prop('checked', this.worldData.disable_guest_restrictions === 1);
    $("#hide_language_selection_edit").prop('checked', this.worldData.hideLanguageSelection === 1 || this.worldData.hideLanguageSelection === true);

    $('#notification_toggle_button').hide();

    this.editMode = model.editMode;

    this.isMobile = isMobile();

    this.visitedRoomsTextures = [];
    this.loadingTextures = {};

    this.objectsInScene = [];
    this.interactionGroup = new Group();
    this.youtubeVideos = new Group();
    this.youtubeInScene = [];     // meshes for YouTube videos (and iframe agents)
    this.vraiAgentsInScene = [];  // meshes for Vrai agents
    this.roomGroup = new Group();
    this.postits = [];
    this.vraiAgentChairs = [];
    this.vraiAgentCameras = [];
    this.vraiAgentTranscriptions = [];
    this.vraiAgentButtons = [];
    this.iframeElementsInScene = [];
    this.timerElementsInScene = [];
    this.inputFieldGuessElementsInScene = [];
    this.inputFieldElementsInScene = [];

    this.roomGroup.add(this.interactionGroup);
    this.roomGroup.add(this.youtubeVideos);

    this.elementSelected = null;
    this.lastValue = 0;
    this.controlsUpdate = true;

    this.needleOffset = 0;

    this.indicatorsArray = [];
    this.elements2dnormal = [];
    this.elements2dTour = [];
    // DOM/performance caches
    this._indicatorDomCache = new Map();
    this._ctaMenus = null;
    this._frameCount = 0;
    this._indicatorUpdateEvery = 2; // update indicators every other frame to reduce DOM churn
    this.followCursor = $("#follow-cursor");
    this.followCursor.hide();
    /**
     * Location name
     */
    $("#room_name").text(this.model.sceneData.name);
    $("#room_name").attr('data-id', this.model.config ? this.model.config.worldId : '');

    $("#location_name").text(this.currentScene.publicName);
    $("#location_name").attr('data-id', this.currentScene.id);
    // $("#room_name").text(`${this.model.sceneData.name}-${this.currentScene.publicName}`);
    $("#mobile-world-dropdown button span.dropdown-title").text(`${this.model.sceneData.name}-${this.currentScene.publicName}`);

    /**
     * Scene
     */

    this.scene = new Scene();
    this.raycaster = new Raycaster();
    this.filtered3DObjects = {};
    this.sizes = { width: window.innerWidth, height: window.innerHeight };
    this.mobileBreakpoint = 600;

    /**
     * Cameras
     */

    this.camera = new PerspectiveCamera(70, 2, 0.001, 10000);
    this.model.camera = this.camera;
    this.camera.position.set(0, 0, .0001);
    this.initialCameraPosition = this.camera.quaternion.clone();

    this.pivot = new Object3D();
    this.pivotX = new Object3D();
    this.pivotX.add(this.camera);
    this.pivot.add(this.pivotX);
    const rotParam = parseFloat(this.urlParams.get('rot'));
    // rot is an edit-mode handoff param; view mode consumes it in _consumeEditModeRotUrlParam().
    this.pivot.rotation.y = this.model.editMode && Number.isFinite(rotParam) ? rotParam : 0;
    this.scene.add(this.pivot);

    this.pivotLastRotation = this.pivot.rotation.y;

    this.cameraPointingMesh = new Mesh(new BoxGeometry(0, 0, 0), new MeshBasicMaterial({ color: "#FF0000" }));
    this.cameraPointingMesh.type = 'cameraPointingMesh';
    this.cameraPointingMesh.name = 'cameraPointingMesh';
    this.cameraPointingMesh.visible = false;
    this.cameraPointingMesh.translateZ(-700);
    this.camera.add(this.cameraPointingMesh);

    /**
    * Renderers
    */

    this.css3DRenderer = new CSS3DRenderer();
    css3DContainer.appendChild(this.css3DRenderer.domElement);
    this.css3DRenderer.domElement.style.pointerEvents = 'auto';
    if (this.css3DRenderer.domElement.firstChild) {
      // this.css3DRenderer.domElement.firstChild.style.pointerEvents = 'auto';
    }

    this.webglRenderer = new WebGLRenderer({
      canvas: webglCanvas,
      antialias: true,
      alpha: true
    });
    // this.webglRenderer.setClearColor(0x000000, 1);
    this.webglRenderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));


    /**
     * Controls
     */

    this.controls = new OrbitControls(this.camera, css3DContainer);
    this.controls.enableDamping = true;
    this.controls.dampingFactor = this.isMobile ? 0.15 : 0.25;
    this.controls.rotateSpeed = this.isMobile ? 1 : 0.25;
    // this.controls.enablePan = false;
    const keyboardOrbitDistance = Math.max(this.camera.position.distanceTo(this.controls.target), 0.0001);
    // In this rig camera->target distance is tiny, so default keyPanSpeed is imperceptible.
    this.controls.keyPanSpeed = Math.round(7 / keyboardOrbitDistance);
    this.controls.keyboardAltMode = true;
    this.controls.keyRotateSpeed = 1.5;
    // Keep wheel/pinch zoom available in edit mode as well.
    this.controls.enableZoom = true;
    // const initialDistance = this.camera.position.distanceTo(this.controls.target);
    // this.controls.minDistance = initialDistance * 0.95;
    // this.controls.maxDistance = initialDistance * 1.05;
    // Set min and max distances for zoom
    this.controls.minDistance = 2;
    this.controls.maxDistance = 5;

    this.controls.rotateSpeed *= -1;
    this.keyboardOrbitPitch = 0;
    this.controls.listenToKeyEvents(window);

    this.enableDeviceOrientationControl = false;
    this.device = new DeviceOrientationState();

    /**
     * Forward input events from iframe (via postMessage) to OrbitControls.
     * Supports:
     *  - pointerdown / pointermove / pointerup / pointercancel (mouse + touch)
     *  - wheel (scroll zoom)
     *
     * Iframe must post messages shaped like:
     *   {
     *     type: 'iframe-mouse-event',
     *     eventCategory: 'pointer' | 'wheel',
     *     eventType: 'pointerdown' | 'pointermove' | 'pointerup' | 'pointercancel' | 'wheel',
     *     ...coords / pointer / wheel fields...
     *   }
     */
    this._iframeMouseHandler = (e) => {
      const data = e.data;
      if (!data || data.type !== 'iframe-mouse-event') return;
      if (!css3DContainer) return;

      if (data.eventCategory === 'pointer') {
        const {
          eventType,
          pointerType,
          pointerId,
          clientX,
          clientY,
          pageX,
          pageY,
          button,
          buttons,
          altKey,
          ctrlKey,
          metaKey,
          shiftKey
        } = data;

        if (!eventType) return;

        const resolvedPageX = pageX != null ? pageX : clientX + (window.scrollX || 0);
        const resolvedPageY = pageY != null ? pageY : clientY + (window.scrollY || 0);

        css3DContainer.dispatchEvent(new PointerEvent(eventType, {
          bubbles: true,
          clientX,
          clientY,
          pageX: resolvedPageX,
          pageY: resolvedPageY,
          button: button != null ? button : 0,
          buttons: buttons != null ? buttons : 1,
          pointerId: pointerId != null ? pointerId : 1,
          pointerType: pointerType || 'mouse',
          altKey: !!altKey,
          ctrlKey: !!ctrlKey,
          metaKey: !!metaKey,
          shiftKey: !!shiftKey
        }));
        return;
      }

      if (data.eventCategory === 'wheel') {
        const { deltaX, deltaY, deltaMode, clientX, clientY } = data;

        css3DContainer.dispatchEvent(new WheelEvent('wheel', {
          bubbles: true,
          deltaX: deltaX != null ? deltaX : 0,
          deltaY: deltaY != null ? deltaY : 0,
          deltaMode: deltaMode != null ? deltaMode : 0,
          clientX,
          clientY
        }));
      }
    };
    window.addEventListener('message', this._iframeMouseHandler);

    /**
     * Textures loading
     */

    const loadingManager = new LoadingManager();
    loadingManager.onStart = () => {
      css3DContainer.style.opacity = 0;
      css3DContainer.style.zIndex = -2;
    }
    this.onStartIntroAnimations = () => {
      if (!this.preloaderCompleted || !this.model.initDeviceCheck) {
        return;
      }
      if (this._introPresentationStarted) {
        return;
      }
      this._introPresentationStarted = true;
      preloader.startHide();
      gsap.to(css3DContainer, { duration: 1, opacity: 1, zIndex: 0, delay: 1 });
      if (this.editMode) {
        //gsap.to(buttonsHolder, { duration: 1, opacity: 1, zIndex: 1, delay: 1 });
        gsap.to(leftSidebar, { duration: 1, opacity: 1, zIndex: 32, delay: 1 });
        gsap.to(showRoomSlider, { duration: 1, opacity: 1, zIndex: 1, delay: 1 });
        this._applyEditModeSphereTileStreaming();
      }
      loadingBarElement.classList.add('ended');
      loadingBarElement.style.transform = '';

      // TINY WORLD ANIMATION
      if (!this.editMode) {
        if (this._introTinyWorldStarted) {
          return;
        }
        this._introTinyWorldStarted = true;
        const cameraDirection = new Vector3();
        this.camera.getWorldDirection(cameraDirection);
        const fromPosition = cameraDirection.multiplyScalar(15000);
        gsap.from(this.sphereMeshLowTexture.material, { opacity: 0, duration: 2.5, delay: .3 });
        gsap.from(this.roomGroup.rotation, { y: Math.PI * 1.4, duration: 2, ease: "back.out(.15)" });

        gsap.from(this.roomGroup.position, {
          duration: 2.5,
          x: fromPosition.x, y: fromPosition.y, z: fromPosition.z,
          // ease: Circ.easeOut,
          ease: "back.out(.75)",
          onStart: () => {
            document.body.classList.add('intro-animation-active');
            this.hideAllElements(false);
            $("#toggleElementsVisibility").prop("checked", false);
            $(".indicator").addClass('opacity');
            this.sphereMesh.visible = true;
            this.sphereMeshLowTexture.visible = false;
            this.model.view?._executeSceneEventActions?.('introAnimationStarted');
          },
          onComplete: () => {
            document.body.classList.remove('intro-animation-active');
            this.model.view?._executeSceneEventActions?.('introAnimationEnded');
            if (this.model.autoSeat) {
              this.model.onTakeFirstEmptySeat();
            }
            this.showAllElements(false);
            $("#toggleElementsVisibility").prop("checked", this.model.showElements);
            $(".indicator").removeClass('opacity');
            this.model.publicStage && this._userEnterPublicStage();
            if (this.model.isEmbed === "0" && !this.model.editMode) {
              this.controls.autoRotate = true;
              this.controls.autoRotateSpeed = .2;
            }
            this.model.dispatchEvent({ type: SCENE_EVENTS.TINY_WORLD_ANIMATION_ENDED });
            const onFirstInteraction = () => {
              this.controls.autoRotate = false;
              this.model.dispatchEvent({ type: SCENE_INTERACTION.PLAY_ALL_VIDEOS_IN_VIDEO_GALLERY });
              window.removeEventListener('pointerdown', onFirstInteraction);
            };
            window.addEventListener('pointerdown', onFirstInteraction);
            this.sphereMesh.visible = false;
            this.sphereMeshLowTexture.visible = true;
            this.sphereController.updateSphereSegments();
            ///set chat to front
            const chatContainer = document.querySelector('.chat-container');
            const chatPanel = document.querySelector('.chat-panel');

            if (chatContainer && chatPanel) {
              document.body.append(chatContainer, chatPanel);
            }
            const disabledPostits = this.model.sceneData.disablePostits === 1;
            if (!disabledPostits) {
              this.model.postitFetcher.getPublicList(this.model.config.worldId, (postits) => {
                this.addPostitsToScene(postits);
              });
            }
          }
        });
      }
    }

    loadingManager.onLoad = () => {
      this.preloaderCompleted = true;
      this.onStartIntroAnimations();
    }
    loadingManager.onProgress = (itemUrl, itemsLoaded, itemsTotal) => {
      const progressRatio = itemsLoaded / itemsTotal;
      preloader.setProgress(progressRatio * 100);
      // loadingBarElement.style.transform = `scaleX(${progressRatio})`;
    }
    loadingManager.onError = (url) => {
      console.log('loadingManager: loading error for url: ' + url);
    }

    this.textureLoader = new TextureLoader(loadingManager);
    this.textureLoaderSilent = new TextureLoader();

    this.lowResUrlImage = getLowResImageUrl(this.currentScene.background.mediumPath);
    this.originalUrl = this.currentScene.background.mediumPath;
    this.lowImageExists = imageExists(this.lowResUrlImage);
    this.bgImgUrl = this.lowImageExists ? this.lowResUrlImage : this.originalUrl;

    // TODO: import textures from texturesAndGeometries.js and assign them to the variables bellow; 
    //       we also need to take in consideration loadingManager which is assigned to this textureLoader
    // Icons must not sit on LoadingManager — they blocked the intro until every
    // chrome texture finished. Only the panorama (below) should gate the preloader.
    this.emptySeatTexture = this.textureLoaderSilent.load('./textures/icons/edit_chair.png');
    this.defaultProfileTexture = this.textureLoaderSilent.load('./textures/profile.png');

    this.webLinkTexture = this.textureLoaderSilent.load('./textures/webLinkHotSpot.png');
    this.sceneChangeTexture = this.textureLoaderSilent.load('./textures/icons/edit_change_scene.png');
    this.youtubeTexture = this.textureLoaderSilent.load('./textures/youtubeWhiteBG.png');
    this.shopLinkTexture = this.textureLoaderSilent.load('./textures/icons/edit_shop.png');

    /**
     * Ambient sound
     */
    this.audioListener = new AudioListener();
    this.camera.add(this.audioListener);
    this.ambientSound = new Audio(this.audioListener);
    this.ambientSound.setLoop(true);
    this.scene.add(this.ambientSound);

    this.audioLoader = new AudioLoader(); // add loading manager

    !this.editMode && this.loadAndPlayAmbientSound(this.currentScene.ambientAudio);

    /**
     * WORLD Object (sphere)
     */

    this.sphereController = new SphereController({ scene: this.scene, camera: this.camera, model: this.model })

    this.updateShphereTextureOnMove = () => {
      if ((this.editMode && this._hasSlicedSphereBackground()) || !this.sphereMesh.visible) {
        this.sphereController.updateSphereSegments();
      }
    }
    document.addEventListener('mousemove', this.updateShphereTextureOnMove, false);
    document.addEventListener('touchmove', this.updateShphereTextureOnMove, false);
    // Keyboard orbit, command look-at, and other non-pointer camera moves never
    // fire mousemove; load hi-res tiles whenever the camera actually changes.
    this.controls.addEventListener('change', this.updateShphereTextureOnMove);

    // Tile segments (VRSphere) use radius 1200; low-res wrapper sits farther in so tiles draw in front.
    const sphereRadius = !this.model.editMode ? 1500 : 1200;
    const lowResSphereRadius = 1500;
    const geometry = new SphereGeometry(sphereRadius, 64, 64);
    const lowResGeometry = new SphereGeometry(lowResSphereRadius, 64, 64);
    const material = new MeshBasicMaterial({
      side: BackSide,
    });

    this.sphereMesh = new Mesh(geometry, material);
    this.sphereMeshLowTexture = new Mesh(lowResGeometry, material);
    this.sphereMesh.renderOrder = -1400;
    this.sphereMeshLowTexture.renderOrder = -1500;
    this.roomGroup.add(this.sphereMesh);
    this.roomGroup.add(this.sphereMeshLowTexture);
    this.sphereMeshLowTexture.visible = false;

    const sphereTexture = this.textureLoader.load(this.bgImgUrl);
    this._updateSphereTexture(sphereTexture);
    // this.textureLoaderSilent.load(this.originalUrl, (texture) => {
    //   this._updateSphereTexture(texture);
    //   this.visitedRoomsTextures.push({ id: this.model.currentScene.background.mediumPath, texture: texture });
    // });
    // this.visitedRoomsTextures.push({ id: this.currentScene.id, texture: sphereTexture });
    this._addElementsToScene(this.currentScene.objects);

    this.scene.add(this.roomGroup);

    // Window resize function
    this.model.smallScreen = false;
    this.resizeTimeout = null;
    window.addEventListener('resize', this.debouncedResize, false);
    this.onWindowResize();

    /** @var {Boolean} render3DWorld Render all object in tick function **/
    this.render3DWorld = true;
    /** @var {Boolean} customRenderMode Render only some custom objects in tick function **/
    this.customRenderMode = false;

    this.model.onSceneInitialised();

    this._pageMediaMuted = false;
    this._initPageMuteToggle();
    this._initPageMediaMuteWatcher();

    // Prevent user from accidentally leaving the app
    window.addEventListener('beforeunload', function (e) {
      //e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
      //e.returnValue = ''; // Chrome requires returnValue to be set
    });

    model.addEventListener(SCENE_INTERACTION.SHOW_ELEMENTS, (e) => {
      this.showAllElements();
    });
    model.addEventListener(SCENE_INTERACTION.HIDE_ELEMENTS, (e) => {
      this.hideAllElements();
    });
    model.addEventListener(SPHERE_CONTROLLER_LOADER.ERROR_TILE_LOADING, (e) => {
      this.sphereMesh.visible = true;
      this.sphereMeshLowTexture.visible = false;
    });
    model.addEventListener(SCENE_EVENTS.RELOAD_POSTITS, (e) => {
      this.removePostitsFromScene();
      this.model.postitFetcher.getPublicList(this.model.config.worldId, (postits) => {
        this.addPostitsToScene(postits);
      });
    });
    // Handle bulma modal close
    const self = this;

    $('.modal-background, .modal-close').on('click', function () {
      if (self.model.iAmInTour() && !self.model.iAmGuide()) {
        return;
      }
      const parent = $(this).parent();
      if (parent.hasClass('space-consent-modal')) {
        return;
      }
      parent.removeClass('is-active');
      closeTinyMCEMoreMenu();

      if (parent.is('#welcomeScreen')) {
        $("#welcomeScreenVideo").length && document.querySelector("#welcomeScreenVideo").pause();
      }
      if (parent.hasClass('take-seat') || parent.hasClass('media-settings-form') || parent.hasClass('shareOnScreen')) {
        self.closePreviewVideoModal();
        return;
      }
      if (parent.is('#infoElementModal')) {
        var videoDom = $('#infoElementVideo');
        if (videoDom.length > 0) {
          videoDom.get(0).pause();
          videoDom.get(0).currentTime = 0; // Reset the video to the start
        }
      }
      var videoDomGallery = $('#videoGalleryVideo');
      if (videoDomGallery.length > 0) {
        videoDomGallery.get(0).pause();
        videoDomGallery.get(0).currentTime = 0; // Reset the video to the start
      }
      self.render3DWorld = true;
      self.customRenderMode = false;
    });

    $('.close-modal').on('click', function () {
      let parent = $(this).parent();
      while (!parent.hasClass('modal') && parent.length) {
        parent = parent.parent();
      }
      if (!parent.length) return;
      if (parent.hasClass('space-consent-modal')) {
        return;
      }
      parent.removeClass('is-active');
      closeTinyMCEMoreMenu();
      if (parent.is('#welcomeScreen')) {
        $("#welcomeScreenVideo").length && document.querySelector("#welcomeScreenVideo video").pause();
      }
      if (parent.hasClass('take-seat') || parent.hasClass('media-settings-form') || parent.hasClass('shareOnScreen')) {
        self.closePreviewVideoModal();
        return;
      }
      if (parent.is('#infoElementModal')) {
        var videoDom = $('#infoElementVideo');
        if (videoDom.length > 0) {
          videoDom.get(0).pause();
          videoDom.get(0).currentTime = 0;
        }
      }
      var videoDomGallery = $('#videoGalleryVideo');
      if (videoDomGallery.length > 0) {
        videoDomGallery.get(0).pause();
        videoDomGallery.get(0).currentTime = 0;
      }
      self.render3DWorld = true;
      self.customRenderMode = false;
    });


    // LEAVE ROOM
    $(document).on('click', '#exit_app', (e) => {
      this._onExitAppClick(e);
    });

    // COMPASS CONTROLS
    $(".compass-rotate-left").on('click', () => {
      this.rotateCameraAnimation(90);
    });
    $(".compass-rotate-right").on('click', () => {
      this.rotateCameraAnimation(-90);
    });
    $(".compass-rotate-back").on('click', () => {
      this.rotateCameraAnimation(-180);
    });

    // DEBUG PANEL
    $("#debug_panel").on("click", function () {
      $(this).hide();
    });

    this.deviceOrientationHandler(false);

    // Initialize auto-rotate controller (skip when Tour mode / disable autorotate is on)
    if (!this.model.editMode && !this.model.sceneData.disableAutorotate) {
      this.autoRotateController = new AutoRotateController(this, this.model);
    }
    this.$compassNeedle = $("#compass-needle");
    this._rayTracingVector = new Vector3();
  };

  _onExitAppClick = (e) => {
    this.model.confirm($trans('exit-app-confirm'), () => {
      if (this.model.customBack) {
        window.close();
        return;
      }
      if (!this.model.editMode) {
        const home = (this.model.sceneData.homeURL || '').trim();
        if (home) {
          const url = /^https?:\/\//i.test(home)
            ? home
            : `https://${home.replace(/^\/+/, '')}`;
          window.location.assign(url);
          return;
        }
      }
      e?.stopPropagation();
      window.location.assign(window.origin);
    }, {
      confirmBtnTxt: $trans('exit-text'),
      cancelBtnTxt: $trans('cancel-text'),
      modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
      modalType: CONFIRM_NOTIFICATION_TYPE.WARNING,
      modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
    });
  }

  deviceOrientationHandler = (first = false) => {
    if (localStorage.getItem('useDeviceOrientation') !== null) {
      const localVal = localStorage.getItem('useDeviceOrientation');
      first && $("#useDeviceOrientation").prop("checked", localVal === 'true');

      if (localVal === 'true') {
        this.device.enable();
        this.enableDeviceOrientationControl = true;
      } else {
        this.enableDeviceOrientationControl = false;
        this.device.disable();
      }
    }
    ///until we have a way to handle device orientation
    this.enableDeviceOrientationControl = false;
    this.device.disable();
  }

  closePreviewVideoModal = () => {
    this.model.activePreviewVideoModal = false;
    $(".media-settings-form").removeClass('is-active');
    $(".take-seat").removeClass('is-active');
  };

  startPreviewVideoModal = (isScreenShare) => {
    this.model.activePreviewVideoModal = true;
    this.model.testStream(isScreenShare);
  };

  loadAndPlayAmbientSound = (source, play = false) => {
    if (source.hasOwnProperty('url')) {
      if (source.url) {

        const volume = source.hasOwnProperty('volume') ? source.volume : 0.5;
        $("#ambientMusicVolume").val(volume);

        this.audioLoader.load(source.url,

          // onLoad callback
          (audioBuffer) => {
            this.ambientSound.isPlaying && this.ambientSound.stop();
            this.ambientSound.setBuffer(audioBuffer);
            if (this._pageMediaMuted) {
              this._ambientVolumeBeforePageMute = volume;
            }
            this.model.userClicked ? this.fadeInAmbientSound(play) : this.playSoundASAP(play);
            if (this._pageMediaMuted) {
              this._schedulePageMediaMuteReapply?.();
            }
          },

          // onProgress callback
          (xhr) => { const progress = (xhr.loaded / xhr.total * 100) + '% loaded'; },

          // onError callback
          (err) => { console.log('An error happened', err); }
        );
      }
    }
  }

  playSoundASAP = (play) => {
    setTimeout(() => {
      this.model.userClicked ? this.fadeInAmbientSound(play) : this.playSoundASAP(play);
    }, 200);
  }

  fadeInAmbientSound = (play) => {
    if ($('#ambientMusic').prop('checked') || play) {
      if (this._pageMediaMuted) {
        this.ambientSound.setVolume(0);
        this.ambientSound.play();
        return;
      }
      this.ambientSound.setVolume(0);
      const volume = this.editMode ? $('#ambient_volume').val() : $('#ambientMusicVolume').val();
      const ambientSound = this.ambientSound;

      gsap.to({}, {
        duration: 3,
        ease: Linear.easeNone,
        onStart: () => {
          this.ambientSound.play();
        },
        onUpdate: function () {
          const ratio = this.ratio * volume;
          ambientSound.setVolume(ratio);
        }
      });
    }
  }

  fadeOutAmbientAudio = (duration = 3) => {
    const volume = this.editMode ? $('#ambient_volume').val() : $('#ambientMusicVolume').val();
    const ambientSound = this.ambientSound;
    gsap.to({}, {
      duration,
      ease: Linear.easeNone,
      onUpdate: function () {
        const ratio = this.ratio * volume;
        ambientSound.setVolume(volume - ratio);
      },
      onComplete: () => {
        this.ambientSound.stop();
      }
    });
  }

  _initPageMediaMuteWatcher() {
    this._reapplyPageMediaMuteIfActive = () => {
      if (!this._pageMediaMuted) {
        return;
      }
      this.toggleMediaMute(true);
    };

    this._schedulePageMediaMuteReapply = () => {
      if (!this._pageMediaMuted) {
        return;
      }
      this._reapplyPageMediaMuteIfActive();
      if (this._pageMediaMuteReapplyTimers?.length) {
        this._pageMediaMuteReapplyTimers.forEach((timerId) => window.clearTimeout(timerId));
      }
      this._pageMediaMuteReapplyTimers = [50, 150, 400, 1000, 2500].map((ms) =>
        window.setTimeout(this._reapplyPageMediaMuteIfActive, ms)
      );
    };

    this._onDynamicMediaForPageMute = () => {
      this._schedulePageMediaMuteReapply();
    };

    this._onMediaPlayForPageMute = (event) => {
      if (!this._pageMediaMuted) {
        return;
      }
      const target = event.target;
      if (target?.matches?.('audio, video') && !target.classList?.contains('already-muted')) {
        this._schedulePageMediaMuteReapply();
      }
    };

    this._pageMediaMuteEventTypes = [
      'vapi-agent-call-start',
      'vapi-agent-media',
      SCENE_EVENTS.START_SCENE_CHANGE,
      SCENE_EVENTS.STOP_SCENE_CHANGE,
      SCENE_INTERACTION.NEW_SCENE_INITIALISED,
      SCENE_INTERACTION.SET_OCCUPIED_SEATS,
      SCENE_INTERACTION.SET_OCCUPIED_SCREEN_SHARE_SEATS,
      WEBRTC_EVENTS.WEBRTC_SOME_VIDEO_STARTED,
      WEBRTC_EVENTS.WEBRTC_USER_STARTED_VIDEO,
      WEBRTC_EVENTS.NEW_STREAM_ON_PUBLIC_STAGE,
      ANT_MEDIA_SERVER_BAGELSS_EVENTS.VIDEO_CREATED,
      ANT_MEDIA_SERVER_BAGELSS_EVENTS.PLAY_STARTED,
    ];

    this._pageMediaMuteEventTypes.forEach((eventType) => {
      this.model?.addEventListener?.(eventType, this._onDynamicMediaForPageMute);
    });

    document.addEventListener('play', this._onMediaPlayForPageMute, true);

    if (typeof MutationObserver === 'undefined' || !document.body) {
      return;
    }

    this._pageMediaMuteObserver = new MutationObserver((mutations) => {
      if (!this._pageMediaMuted) {
        return;
      }
      let shouldReapply = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) {
              return;
            }
            if (node.matches?.('audio, video') || node.querySelector?.('audio, video')) {
              shouldReapply = true;
            }
          });
        } else if (mutation.type === 'attributes' && mutation.target?.matches?.('audio, video')) {
          shouldReapply = true;
        }
      });
      if (shouldReapply) {
        this._schedulePageMediaMuteReapply();
      }
    });

    this._pageMediaMuteObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['muted'],
    });
  }

  _initPageMuteToggle() {
    const $btn = $('#page_media_mute_toggle');
    if (!$btn.length) {
      return;
    }
    $btn.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.setPageMediaMuted(!this._pageMediaMuted);
    });
    this._updatePageMuteButton();
  }

  setPageMediaMuted(muted) {
    this._pageMediaMuted = !!muted;
    if (this.model) {
      this.model.pageMediaMuted = this._pageMediaMuted;
    }
    this.toggleMediaMute(this._pageMediaMuted);
    this._updatePageMuteButton();
  }

  _applyPageMuteToVrMusicObjects(muted) {
    const musicObjects = this.filtered3DObjects?.vrMusicObject;
    if (!musicObjects?.length) {
      return;
    }
    musicObjects.forEach((musicObj) => {
      if (typeof musicObj?.applyPageMediaMute === 'function') {
        musicObj.applyPageMediaMute(muted);
      } else if (musicObj?.audioEl) {
        this._setPageMediaElementMuted(musicObj.audioEl, muted);
      }
    });
  }

  _stopSceneLoopedSounds() {
    const musicObjects = this.filtered3DObjects?.vrMusicObject;
    musicObjects?.forEach?.((musicObj) => {
      musicObj.stopPlaying?.();
    });
    const audioRoot = document.getElementById('page-media-audio-root');
    audioRoot?.querySelectorAll?.('audio').forEach((audio) => {
      audio.pause();
      audio.loop = false;
      try {
        audio.currentTime = 0;
      } catch (_) { }
    });
  }

  _updatePageMuteButton() {
    const $btn = $('#page_media_mute_toggle');
    if (!$btn.length) {
      return;
    }
    $btn.toggleClass('is-muted', this._pageMediaMuted);
    const langKey = this._pageMediaMuted ? 'unmute-text' : 'mute-text';
    if (typeof $trans === 'function') {
      const label = $trans(langKey);
      $btn.attr('title', label);
      $btn.attr('aria-label', label);
    }
  }

  _setPageMediaElementMuted(elem, muted) {
    if ($(elem).hasClass('already-muted')) {
      return;
    }
    if (muted) {
      if (!elem.dataset.pageMutedByToggle) {
        elem.dataset.pageMutedByToggle = '1';
      }
      elem.muted = true;
      return;
    }
    if (elem.dataset.pageMutedByToggle) {
      elem.muted = false;
      delete elem.dataset.pageMutedByToggle;
    }
  }

  toggleMediaMute = (state) => {
    document.querySelectorAll('audio, video').forEach((elem) => {
      this._setPageMediaElementMuted(elem, state);
    });

    this._applyPageMuteToVrMusicObjects(state);

    const volumeSlider = this.editMode ? $('#ambient_volume').val() : $('#ambientMusicVolume').val();
    const fallbackVolume = Number(volumeSlider);
    const fallback = Number.isFinite(fallbackVolume) ? fallbackVolume : 0.5;

    if (this.ambientSound) {
      if (state) {
        if (this._ambientVolumeBeforePageMute == null) {
          const current = this.ambientSound.getVolume?.();
          this._ambientVolumeBeforePageMute = Number.isFinite(current) ? current : fallback;
        }
        this.ambientSound.setVolume(0);
      } else if (this._ambientVolumeBeforePageMute != null) {
        this.ambientSound.setVolume(this._ambientVolumeBeforePageMute);
        this._ambientVolumeBeforePageMute = null;
      }
    }
  }

  tick = () => {
    if (!this.render3DWorld) {
      requestAnimationFrame(this.tick);
      return;
    }

    // region Custom render mode item here
    if (!this.model.editMode) {
      this.filtered3DObjects["audioAnalyzer"]?.forEach?.(item => {
        item.update();
      })
    }
    // endregion Custom render mode item here

    // If this is true, we are in custom render mode, only render some objects
    if (this.customRenderMode) {
      requestAnimationFrame(this.tick);
      return;
    }

    if (!this.model.isAnimating && this.camera.fov > 120) {
      this.camera.fov = 120;
      this.camera.updateProjectionMatrix();
    }
    if (!this.model.isAnimating && this.camera.fov < 22) {
      this.camera.fov = 22;
      this.camera.updateProjectionMatrix();
    }
    // OrbitControls with enableDamping must call update() every frame so sphericalDelta
    // decays after pointer-up; otherwise stale deltas combine badly with the next drag
    // (often noticed after keyboard orbit, which never invokes update).
    if (!this.model.isAnimating && this.controls && (this.controls.enableDamping || this.controls.autoRotate)) {
      this.controls.update();
    }
    if (this.editMode && this._hasSlicedSphereBackground() && this.sphereController) {
      this.sphereController.updateSphereSegments();
    }
    if (this.enableDeviceOrientationControl && !this.model.isAnimating) {
      if (this.isMobile) {
        this.pivot.rotation.y = this.device.angleX() + this.device.angleZ();
        // this.pivotX.rotation.x = this.device.angleY() - Math.PI/2;
      }

      // $("#debug_panel").html(`
      // <p>angleX : ${this.device.angleX()}</p>
      // <p>angleY : ${this.device.angleY()}</p>
      // <p>angleZ : ${this.device.angleZ()}</p>
      // <p>pivot rot Y : ${this.pivot.rotation.y}</p>
      // <p>pivot rot X : ${this.pivotX.rotation.x}</p>
      // `);

      // $("#debug_panel").addClass("visible");
    } else {
      this.pivotX.rotation.x = this.keyboardOrbitPitch;
      $("#debug_panel").html("");
      $("#debug_panel").removeClass("visible");
    }

    // this.stats.update();

    this.updateCompass();
    this.postits.forEach(postit => {
      postit.render(this.camera);
    });
    this.vraiAgentChairs.forEach(chair => {
      chair.render(this.camera);
    });
    this.vraiAgentCameras.forEach(cam => {
      cam.render(this.camera);
    });
    this.iframeElementsInScene.forEach((iframeEl) => {
      iframeEl.render(this.camera);
    });
    this.timerElementsInScene.forEach((timerEl) => {
      timerEl.render(this.camera);
    });
    this.inputFieldGuessElementsInScene.forEach((guessEl) => {
      guessEl.render(this.camera);
    });
    this.inputFieldElementsInScene.forEach((inputEl) => {
      inputEl.render(this.camera);
    });

    // Increment frame counter and throttle indicator DOM updates to reduce per-frame cost
    this._frameCount = (this._frameCount + 1) | 0;
    const doIndicators = (this._frameCount % (this._indicatorUpdateEvery || 1) === 0);

    // Update indicator DOM positions and visibility
    if (doIndicators && this.indicatorsArray.length) {
      const canvasEl = this.webglRenderer?.domElement;
      const rect = canvasEl?.getBoundingClientRect?.();
      const viewportCenterX = window.innerWidth * 0.5;
      const viewportCenterY = window.innerHeight * 0.5;
      const canvasCenterX = rect ? rect.left + rect.width * 0.5 : viewportCenterX;
      const canvasCenterY = rect ? rect.top + rect.height * 0.5 : viewportCenterY;
      const offsetX = canvasCenterX - viewportCenterX;
      const offsetY = canvasCenterY - viewportCenterY;
      for (const indicator of this.indicatorsArray) {
        let el = this._indicatorDomCache.get(indicator.element);
        if (!el) {
          const list = document.getElementsByClassName(indicator.element);
          el = list && list.length ? list[list.length - 1] : null;
          if (el) {
            this._indicatorDomCache.set(indicator.element, el);
          } else {
            continue;
          }
        }
        const { intersects, translateX, translateY } = this.get2DSpaceCoordinates(indicator.mesh, rect?.width, rect?.height);
        const isTaken = el.classList.contains('taken');
        const isVapiComponent = indicator.element && (String(indicator.element).startsWith('vapi-camera2d-') || String(indicator.element).startsWith('vapi-transcription2d-') || String(indicator.element).startsWith('vapi-button2d-'));
        const isVapiCamera = indicator.element && String(indicator.element).startsWith('vapi-camera2d-');
        const isVapiTranscription = indicator.element && String(indicator.element).startsWith('vapi-transcription2d-');
        const isVapiButton = indicator.element && String(indicator.element).startsWith('vapi-button2d-');
        let hasActiveStream = false;
        if (isVapiCamera) {
          const video = el.querySelector('.vrai-webcam');
          if (video?.srcObject) {
            const tracks = video.srcObject.getTracks?.() || [];
            hasActiveStream = tracks.some(t => t.readyState === 'live');
          }
        }
        const isEditModeIndicator = this.editMode && isVapiComponent;
        let belongsToActiveChair = false;
        if (!this.editMode && this.vraiAgentChairs?.length && isVapiComponent && !isVapiCamera) {
          const comp = indicator.mesh?.userData?.vraiAgentCamera || indicator.mesh?.userData?.vraiAgentTranscription || indicator.mesh?.userData?.vraiAgentButton;
          const agentId = comp?.dbConfig?.vapiAgentId ?? comp?.getDbConfig?.()?.vapiAgentId;
          if (agentId != null) {
            const chair = this.vraiAgentChairs.find(c => String(c.id || c.getId?.()) === String(agentId));
            belongsToActiveChair = !!(chair?._vapiCallActive || chair?._vapiConnecting);
          }
        }
        // visible = shown, no visible = hidden. hide-on-start / hidden-by-action: never add visible from tick.
        // shown-by-action: explicitly shown via show action, tick must not override.
        const hasHideOnStart = el.classList.contains('hide-on-start');
        const hasHiddenByAction = el.classList.contains('hidden-by-action');
        const hasShownByAction = el.classList.contains('shown-by-action');
        const shouldBeVisible = (hasHideOnStart || hasHiddenByAction)
          ? false
          : hasShownByAction
            ? true
            : (isVapiComponent
              ? (isVapiButton
                ? this.editMode
                : ((isVapiCamera || isVapiTranscription) ? true : (isEditModeIndicator || hasActiveStream || belongsToActiveChair)))
              : ((intersects && !isTaken) || hasActiveStream));
        const isVisibleNow = el.classList.contains('visible');
        if (shouldBeVisible !== isVisibleNow) {
          el.classList.toggle('visible', shouldBeVisible);
        }
        el.style.transform = `translate(${offsetX + translateX}px, ${offsetY + translateY}px)`;
      }
    }

    // Cache .cta-menu elements once
    if (!this._ctaMenus) {
      this._ctaMenus = Array.from(document.querySelectorAll('.cta-menu'));
    }
    // Compute menu position once per tick if needed
    let menuTranslateX, menuTranslateY, menuPosComputed = false;
    for (const el of (this._ctaMenus || [])) {
      const hasActive = el.classList.contains('is-active');
      if (hasActive) {
        if (el.classList.contains('pinned')) {
          el.style = '';
        } else {
          if (!menuPosComputed && this.elementSelected && this.elementSelected.menuPosition) {
            const coords = this.get2DSpaceCoordinates(this.elementSelected.menuPosition);
            menuTranslateX = coords.translateX;
            menuTranslateY = coords.translateY;
            menuPosComputed = true;
          }
          if (menuPosComputed) {
            const next = `translate(${menuTranslateX}px, ${menuTranslateY}px) translateX(-50%)`;
            if (el.style.transform !== next) {
              el.style.transform = next;
            }
          }
        }
      } else {
        el.style = '';
      }
    }

    this.webglRenderer.render(this.scene, this.camera);
    this.css3DRenderer.render(this.scene, this.camera);
    // Chair floating overlays use getBoundingClientRect — must run after CSS3DRenderer updates DOM.
    this.vraiAgentChairs.forEach(chair => {
      chair.syncFloatingOverlays?.();
    });

    if (!this.model.editMode) {
      this.filtered3DObjects["guestSeat"] && this.filtered3DObjects["guestSeat"].map(item => {
        item.update(this.clock);
      })
      this.model.view?._updateCameraRaycastHover?.();
    }

    requestAnimationFrame(this.tick);
  }

  rotateCameraAnimation = (angle) => {
    let rotateY = this.pivot.rotation.y + degrees_to_radians(angle);
    this.pivotLastRotation = rotateY;
    gsap.to(this.pivot.rotation, {
      y: rotateY,
      duration: .5
    });
  }

  onWindowResize = () => {
    const width = webglCanvas.clientWidth;
    const height = webglCanvas.clientHeight;
    if (this.model.userListOpened && window.innerWidth < 600) {
      $(".chat-all-container").css("z-index", '');
      $(".people-all-container").css("z-index", 40);
    } else {
      $(".chat-all-container").css("z-index", 39);
      $(".people-all-container").css("z-index", '');
    }

    if (webglCanvas.width !== width || webglCanvas.height !== height) {
      this.webglRenderer.setSize(width, height, false);
      this.css3DRenderer.setSize(width, height, false);

      $('.localVideoWrapper').removeAttr('style');

      if (width < this.mobileBreakpoint || height < this.mobileBreakpoint) {
        $(".cta-menu").addClass('pinned');
      } else {
        $(".cta-menu").removeClass('pinned');
      }

      if (this.editMode) {
        const cond = $(".settings-menu").hasClass("is-active") && !$(".settings-menu").hasClass("fixed") && window.innerWidth > 1050;
        $(".bottom-bar-room-settings").toggleClass("offset", cond);
      }

      if (width < this.mobileBreakpoint) {
        if (!this.model.smallScreen) {
          this.camera.fov = 90;
        }
        this.model.smallScreen = true;
      } else {
        if (this.model.smallScreen) {
          this.camera.fov = 70;
        }
        this.model.smallScreen = false;
      }

      this.sizes = { width, height }
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();
    }

    $(".localVideoWrapper").hasClass("focus-mode") && $("#gridToggle").css({ right: `${document.querySelector("#localVideoContainer").getBoundingClientRect().width / 2}px` });
    this.resizeChessGames();
  }

  resizeChessGames() {
    return;
    // Check if we're on desktop (not matching your mobile conditions)
    const isDesktop = window.matchMedia('(min-width: 1025px)').matches;
    const isMobileLandscape = window.matchMedia('(max-width: 1024px) and (orientation: landscape)').matches;

    if (isDesktop) {
      // Select only modals with the chess-game class
      const chessModals = document.querySelectorAll('.modal.chess-game .modal-card');
      chessModals.forEach(modalCard => {
        // Get the total available width (window width minus padding)
        const totalWidth = window.innerWidth - 48; // 24px padding on each side
        const sectionWidth = totalWidth / 3; // Each section takes 1/3 of the width

        // Set the width of each section
        const chessGame = modalCard.querySelector('.chess-game-container');
        const chessWatchers = modalCard.querySelector('.chess-watchers');
        const chessPlayers = modalCard.querySelector('.chess-players');

        if (chessGame) {
          chessGame.style.width = `${sectionWidth}px`;
          chessGame.style.height = `${sectionWidth}px`; // Keep it square
          // Set modal-card height to match chess-game-container height
          modalCard.style.height = `${sectionWidth}px`;
        }

        if (chessWatchers) {
          chessWatchers.style.width = `${sectionWidth}px`;
        }

        if (chessPlayers) {
          chessPlayers.style.width = `${sectionWidth}px`;
        }
      });
    } else if (isMobileLandscape) {
      const chessModals = document.querySelectorAll('.modal.chess-game .modal-card');
      chessModals.forEach(modalCard => {
        const totalHeight = window.innerHeight - 48; // 24px padding on top and bottom
        const sectionHeight = totalHeight / 3; // Each section takes 1/3 of the height

        const chessGame = modalCard.querySelector('.chess-game-container');
        const chessWatchers = modalCard.querySelector('.chess-watchers');
        const chessPlayers = modalCard.querySelector('.chess-players');

        if (chessGame) {
          // Set chess game to be square and centered
          const gameSize = Math.min(sectionHeight, window.innerWidth - 48);
          chessGame.style.width = `${gameSize}px`;
          chessGame.style.height = `${gameSize}px`;
          chessGame.style.margin = '0 auto';
        }

        if (chessWatchers) {
          // Set watchers to full width and fixed height
          chessWatchers.style.width = '100%';
          chessWatchers.style.height = `${sectionHeight}px`;
          // Make children align in a row
          const watcherItems = chessWatchers.querySelectorAll('.chess-watcher');
          watcherItems.forEach(item => {
            item.style.display = 'inline-block';
            item.style.width = 'auto';
            item.style.height = '100%';
          });
        }

        if (chessPlayers) {
          // Set players to full width and fixed height
          chessPlayers.style.width = '100%';
          chessPlayers.style.height = `${sectionHeight}px`;
          // Make children align in a row
          const playerItems = chessPlayers.querySelectorAll('.chess-player');
          playerItems.forEach(item => {
            item.style.display = 'inline-block';
            item.style.width = 'auto';
            item.style.height = '100%';
          });
        }

        // Set modal card height to fit all sections
        modalCard.style.height = `${totalHeight}px`;
      });
    }
  }

  addCursor = (withCrosshair = true) => {

    if (withCrosshair) {
      const mainCursorEditor = document.createElement('img');
      mainCursorEditor.src = `textures/mainCursorEditor.png`;
      crosshairHolder.appendChild(mainCursorEditor);
    }

    //     const loading = document.createElement('img');
    //     loading.setAttribute('class', 'loading-spinner');
    //     loading.src = `textures/loading.gif`;

    //     const load = $(`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    // <path d="M-4.40015e-05 0.666835C3.06413 0.666835 6.09831 1.27037 8.92924 2.44298C11.7602 3.61559 14.3324 5.33431 16.4991 7.50101C18.6658 9.66771 20.3845 12.24 21.5571 15.0709C22.7298 17.9018 23.3333 20.936 23.3333 24.0002L15.1666 24.0002C15.1666 22.0085 14.7743 20.0362 14.0121 18.1961C13.2499 16.356 12.1328 14.6841 10.7244 13.2757C9.31605 11.8674 7.64409 10.7502 5.80399 9.98799C3.96388 9.2258 1.99167 8.8335 -4.36446e-05 8.8335L-4.40015e-05 0.666835Z" fill="url(#paint0_angular_66_9650)"/>
    // <defs>
    // <radialGradient id="paint0_angular_66_9650" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-4.29816e-05 24.0002) rotate(-90) scale(23.3333 23.3333)">
    // <stop offset="0.9999" stop-color="#6B9D11"/>
    // <stop offset="1" stop-color="#00AFAA" stop-opacity="0.01"/>
    // </radialGradient>
    // </defs>
    // </svg>
    // `)

    $(loadingSpinnerHolder).append($(`
<div class="container">
  <div class="columns">

    <div class="column is-6 is-offset-3">
      <div class="box">
        <div class="loader-wrapper-cross">
          <div class="loader is-loading-cross">
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>`));

  }
  // <div class="wrapper-loading-image" style="position: absolute; width: 100%; height: 100%;">
  //   <img src="./textures/bagless_logo.png" style="width: fit-content; height: fit-content; opacity: .4;">
  // </div>

  setControlsUpdate = state => {
    this.controlsUpdate = state;
  }

  getAvatar = () => {
    const userProperties = this.model.getUserData();
    return isNaN(userProperties.userId) ? getCookie('guestAvatarUrl') : userProperties.userAvatarUrl;
  }


  /**
   * @param {path} path
   */
  _getTexture(path) {
    return this.textureLoaderSilent.load(path);
  }

  _hasSlicedSphereBackground(scene = this.currentScene) {
    const bg = scene?.background;
    return Boolean(
      bg?.sliceImage &&
      bg?.mediumPath &&
      bg?.type !== 'video'
    );
  }

  /**
   * Edit mode sliced pano: hide both wrapper spheres; only VRSphere tile segments draw.
   */
  _applySlicedSphereTileVisibility() {
    if (!this._hasSlicedSphereBackground() || !this.sphereController) {
      return false;
    }
    const sceneId = this.currentScene?.id;
    const currentSphere = sceneId ? this.sphereController.vrSpheres[sceneId] : null;
    if (!currentSphere) {
      return false;
    }
    this.sphereController.currentSphere = currentSphere;
    Object.values(this.sphereController.vrSpheres).forEach((vrSphere) => {
      vrSphere.sphereGroup.visible = vrSphere === currentSphere;
    });
    if (this.editMode) {
      currentSphere.setInitRotation(0);
    }
    if (this.sphereMesh) {
      this.sphereMesh.visible = false;
    }
    // Match view mode: low-res full pano stays visible while hi-res tiles stream in.
    if (this.sphereMeshLowTexture) {
      this.sphereMeshLowTexture.visible = true;
    }
    this.sphereController.updateSphereSegments();
    return true;
  }

  _applyEditModeSphereTileStreaming() {
    if (!this.editMode) {
      return;
    }
    if (this._applySlicedSphereTileVisibility()) {
      return;
    }
    if (this.sphereController) {
      Object.values(this.sphereController.vrSpheres).forEach((vrSphere) => {
        vrSphere.sphereGroup.visible = false;
      });
    }
    if (this.sphereMesh) {
      this.sphereMesh.visible = true;
    }
    if (this.sphereMeshLowTexture) {
      this.sphereMeshLowTexture.visible = false;
    }
  }

  /**
   * @param {obj} bgObj
   */
  _updateSphereTexture(newBgImage) {

    if (this.sphereMesh.material.map && this.sphereMesh.material.map.image) {
      const currentImageFileName = this.sphereMesh.material.map.image.currentSrc;
      const newBgImageFileName = newBgImage.image.currentSrc;
      const wantedImage = this.currentScene?.background?.mediumPath;
      if (!wantedImage || !areSameResource(newBgImageFileName, wantedImage)) {
        return;
      }
    }

    newBgImage.wrapS = RepeatWrapping;
    newBgImage.repeat.x = - 1;
    this.sphereMesh.material.map = newBgImage;
    this.sphereMesh.material.needsUpdate = true;
  }

  _reportMissingObject(reason, data = {}, err) {
    const payload = {
      reason,
      type: data?.type,
      name: data?.name,
      id: data?.id,
    };
    console.log('[Scene3D] Object could not be loaded', payload, err || '');
    console.warn(`[Scene3D] ${reason}`, payload, err || '');
    if (!this._skippedSceneObjects) this._skippedSceneObjects = [];
    this._skippedSceneObjects.push(payload);
  }

  _flushMissingObjectWarnings() {
    const skipped = this._skippedSceneObjects || [];
    this._skippedSceneObjects = [];
    if (!skipped.length) return;
    const labels = skipped.map((s) => s.name || s.type || s.id).filter(Boolean);
    const preview = labels.slice(0, 3).join(', ');
    const extra = labels.length > 3 ? ` +${labels.length - 3}` : '';
    const names = `${preview}${extra}`;
    const msg = skipped.length === 1
      ? $trans('error-object-could-not-load', { name: names }, `An object could not be loaded (${names}). It may be missing or unsupported.`)
      : $trans('error-objects-could-not-load', { count: String(skipped.length), names }, `${skipped.length} objects could not be loaded (${names}). They may be missing or unsupported.`);
    this.model?.alert?.('error', msg);
  }

  _notifyMissingScene(sceneId) {
    console.log('[Scene3D] Scene does not exist', sceneId);
    console.warn('[Scene3D] Scene does not exist', sceneId);
    this.model?.alert?.(
      'error',
      $trans('error-scene-does-not-exist', {}, 'This scene does not exist and could not be opened.')
    );
  }

  async _addElementsToScene(sceneobjects) {
    this._skippedSceneObjects = [];
    sceneobjects = Array.isArray(sceneobjects) ? [...sceneobjects] : [];
    if (!this.model.editMode) {
      sceneobjects = sceneobjects.filter(item => item?.type !== 'tourScreenShare');
      sceneobjects.forEach(item => {
        if (item.type === 'screenStream') {
          const newItem = { ...item, type: 'tourScreenShare' };
          sceneobjects.push(newItem);
        }
      });
    }
    if (this.model.isEmbed === "0") {
      sceneobjects = sceneobjects.filter(item => item.type === SCENE_OBJECT_TYPES.sceneChange);
    }

    this.filtered3DObjects = {};
    this.indicatorsArray = [];
    $(".indicator").remove();
    $(".indicator").addClass("opacity");
    // reset DOM/performance caches
    this._indicatorDomCache && this._indicatorDomCache.clear();
    this._ctaMenus = null;
    this._frameCount = 0;

    const objectsWithIndicators = ['screenStream', 'guestSeat', 'screenStream', 'webLink', 'sceneChange', 'payPalDonation', 'chessGame', 'infoElement', 'shopLink', 'embeddedWebpage', 'tourScreenShare', 'videoPlayer', 'videoPlayerWebGL', 'imageGallery'];

    for (let x = 0; x < sceneobjects.length; x++) {
      try {
        let elTexture;
        let userInfo = false;
        const type = sceneobjects[x]?.type;
        if (!type) {
          this._reportMissingObject('Object has no type', sceneobjects[x]);
          continue;
        }

        if (type === 'vraiAgent' || type === 'vapiUserCamera' || type === 'vapiTranscription' || type === 'vapiButton' || type === 'iframeElement' || type === 'timerElement' || type === 'inputFieldGuess' || type === 'inputField') continue;
        if (type === 'css3dTest' || type === 'embeddedCode' || type === 'vrInvisibleCameraMovement') {
          this._reportMissingObject('Unsupported object type', sceneobjects[x]);
          continue;
        }

        switch (type) {
          case 'guestSeat':
            if (sceneobjects[x].profile && JSON.stringify({}) !== JSON.stringify(sceneobjects[x].profile)) {
              userInfo = true;
            }
            elTexture = userInfo ? this.textureLoaderSilent.load(`./textures/${sceneobjects[x].profile.avatar}`) : this.emptySeatTexture;
            break;
          case 'profile':
            elTexture = sceneobjects[x].profile?.avatarImage?.mediumPath ? this.textureLoaderSilent.load(`${sceneobjects[x].profile.avatarImage.mediumPath}`) : this.defaultProfileTexture;
            break;
          // Edit mode without custom image uses empty mesh + 2D indicator (same look as view mode).
          case 'sceneChange': elTexture = this.editMode ? emptyTexture : this.sceneChangeTexture; break;
          case 'screenStream': elTexture = this.screenShareTexture; break;
          case 'tourScreenShare': elTexture = this.tourModeScreenShareTexture; break;
          case 'webLink': elTexture = this.editMode ? emptyTexture : this.webLinkTexture; break;
          case 'baglessRoom': elTexture = this.editMode ? this.webLinkTexture : baglessRoomLockTexture; break;
          case 'youtube': elTexture = ''; break;
          case 'iframeAgent': elTexture = ''; break;
          case 'iframeElement': elTexture = ''; break;
          case 'timerElement': elTexture = ''; break;
          case 'vraiAgent': elTexture = ''; break;
          case 'vapiUserCamera': elTexture = ''; break;
          case 'vapiTranscription': elTexture = ''; break;
          case 'vapiButton': elTexture = ''; break;
          case 'chessGame': elTexture = this.editMode ? chessTexture : emptyTexture; break;
          case 'payPalDonation': elTexture = paypalDonateTexture; break;
          case 'shopLink': elTexture = this.shopLinkTexture; break;
          case 'infoElement': elTexture = this.editMode ? emptyTexture : infoTexture; break;
          case 'vrInvisibleAction': elTexture = emptyTexture; break;
          case 'embeddedWebpage': elTexture = this.editMode ? emptyTexture : infoTexture; break;
          case 'imageGallery':
            elTexture = sceneobjects[x].useIcon ? emptyTexture : imageGallery;
            if (!sceneobjects[x].useIcon && sceneobjects[x].images?.length > 0)
              elTexture = imageGalleryLoading;
            break;
          case 'videoGallery': elTexture = imageGalleryLoading; break;
          case 'vrMusicObject': elTexture = musicObjectTexture; break;
        }


        const obj = new VRPlaceObject(x, sceneobjects[x], elTexture, this.editMode, this.model);
        if (!obj?.mesh) {
          this._reportMissingObject('Object has no mesh or type is unknown', sceneobjects[x]);
          continue;
        }
        obj.camera = this.camera;
        obj.controls = this.controls;
        // Preserve "hide on start" for mesh-based objects (e.g. webLink with uploaded image).
        // Indicator-based objects already get hide-on-start via indicator classes.
        if (!this.editMode && sceneobjects[x]?.hideOnStart && obj?.mesh) {
          obj.mesh.visible = false;
          if (obj.mesh.material && !Array.isArray(obj.mesh.material)) {
            obj.mesh.material.opacity = 0;
            obj.mesh.material.needsUpdate = true;
          }
        }

        if (type === 'screenStream') {
          // Ensure loading screen uses same baseline Z as screen share and inherits roomGroup transforms
          const _Z = sceneobjects[x].z || 90;
          const loadingScreen = new VRLoadingScreen(this.camera, sceneobjects[x].x, sceneobjects[x].y, _Z, this.roomGroup);
          this.roomGroup.add(loadingScreen.object);
          obj.loadingScreen = loadingScreen;
          obj.loadingScreen.remove();
        }

        if (!this.filtered3DObjects[type]) {
          this.filtered3DObjects[type] = [];
        }
        this.filtered3DObjects[type].push(obj);

        if (userInfo) {
          // obj.setAsOccupied(sceneobjects[x].profile);
        }
        if (type !== 'youtube' && type !== 'iframeAgent' && type !== 'iframeElement' && type !== 'timerElement' && type !== 'vraiAgent' && type !== 'vapiUserCamera' && type !== 'vapiTranscription' && type !== 'vapiButton') {
          obj.mesh.lookAt(this.camera.position);
          obj.withStaticRotations && obj.setInitRotations(true);
          obj.setDistance(sceneobjects[x].distance ?? sceneobjects[x].size);
          this.interactionGroup.add(obj);
          obj !== null && this.objectsInScene.push(obj.mesh);
          // Dummy always looks at the camera (ignores parent rotations) and is the
          // animation target in _sceneChangeClickEvent — needed for both icon and custom-image scene changes.
          type === 'sceneChange' && !this.editMode && obj.addDummyPositionElement();
        } else {
          if (this.editMode) {
            obj.mesh.lookAt(this.camera.position);
            obj.withStaticRotations && obj.setInitRotations(true);
            obj.setDistance(sceneobjects[x].distance ?? sceneobjects[x].size);
            obj.updatePoster && obj.updatePoster();
            this.interactionGroup.add(obj);
            if (obj !== null) {
              this.objectsInScene.push(obj.mesh);
              if (obj.getComponentMeshesForRaycast) {
                this.objectsInScene.push(...obj.getComponentMeshesForRaycast());
              }
            }

          } else {
            obj.lookAt && obj.lookAt(this.camera.position);

            if (type === 'youtube' || type === 'iframeAgent') {
              this.youtubeVideos.add(obj);
              obj !== null && this.youtubeInScene.push(obj.mesh);
            } else if (type === 'vapiCamera' || type === 'vapiUserCamera' || type === 'vapiTranscription' || type === 'vapiButton') {
              this.roomGroup.add(obj);
              obj !== null && this.objectsInScene.push(obj.mesh);
            }
          }
        }

        // View mode: all indicator types. Edit mode: default-icon objects without custom image.
        const allowEditModeDefaultIndicator = this.model.editMode
          && (type === 'sceneChange' || type === 'webLink' || type === 'videoPlayer' || type === 'infoElement' || type === 'embeddedWebpage' || type === 'imageGallery')
          && (typeof obj.isIndicatorMode === 'function' ? obj.isIndicatorMode() : !obj.customIcon);
        if (objectsWithIndicators.includes(type) && (!this.model.editMode || allowEditModeDefaultIndicator)) {
          let cls, icon;

          const tooltip = sceneobjects[x].tooltip || getTooltipByType(type) || '';
          const dataLangKey = String(tooltip).replaceAll(" ", "-").toLowerCase();
          const finalTooltip = multiLanguagesController.languageObject.hasOwnProperty(dataLangKey) ? multiLanguagesController.languageObject[dataLangKey].text : tooltip;

          switch (type) {
            case 'guestSeat': cls = 'chair-indicator'; icon = 'chair'; break;
            case 'screenStream': cls = 'screen-share-indicator'; icon = 'screen_share'; break;
            case 'webLink': cls = 'web-link-indicator'; icon = 'link'; break;
            case 'sceneChange': {
              const targetSceneId = obj.dbConfig?.goToSceneId;
              const targetScene = targetSceneId != null ? this.model.scenes[targetSceneId] : null;
              const locationWithPayment = targetScene?.locationWithPayment;
              const withPayment = locationWithPayment != null
                && Object.prototype.hasOwnProperty.call(locationWithPayment, 'state')
                && locationWithPayment.state;
              cls = withPayment ? 'scene-change-indicator withPayment' : 'scene-change-indicator';
              icon = 'door_front';
              if (obj.dbConfig?.customIcon) {
                icon = obj.dbConfig.customIcon;
              }
              if (typeof obj.isIndicatorMode === 'function' ? !obj.isIndicatorMode() : obj.customIcon) {
                cls = '';
              }
              break;
            }
            case 'payPalDonation': cls = 'p aypal-donation-indicator'; icon = 'volunteer_activism'; break;
            case 'chessGame': cls = 'chess-indicator'; icon = 'chess'; break;
            case 'infoElement': cls = 'info-indicator'; icon = 'info'; break;
            case 'embeddedWebpage': {
              cls = 'embedded-webpage-indicator';
              icon = 'info';
              if (typeof obj.isIndicatorMode === 'function' ? !obj.isIndicatorMode() : obj.customIcon) {
                cls = '';
              }
              break;
            }
            case 'shopLink': cls = 'shop-indicator'; icon = 'shopping_cart'; break; //TODO get random product + image in extended tooltip title
            // case 'tourScreenShare': cls = 'shop-indicator tour-mode'; icon = 'shopping_cart'; break; //TODO get random product + image in extended tooltip title
            case 'tourScreenShare': cls = 'tour-screen-share-indicator'; icon = 'screen_share'; break; //TODO get random product + image in extended tooltip title
            case 'videoPlayer':
            case 'videoPlayerWebGL': cls = 'video-player-indicator'; icon = 'play_circle'; break;
            case 'imageGallery': {
              cls = 'image-gallery-indicator';
              icon = 'photo_library';
              if (typeof obj.isIndicatorMode === 'function' ? !obj.isIndicatorMode() : obj.customIcon) {
                cls = '';
              }
              break;
            }
          }

          if (cls !== '' && !obj.customIcon) {
            this._attachObjectIndicator(obj, {
              cls,
              icon,
              tooltip: finalTooltip,
              dataLangKey,
              hideMesh: !this.editMode && type !== 'chessGame',
              editModePreview: this.editMode,
              hideOnStart: !this.editMode && !!sceneobjects[x].hideOnStart,
              isTourScreenShare: type === 'tourScreenShare',
              isChess: type === 'chessGame',
            });
          }

        }
      } catch (err) {
        this._reportMissingObject('Object failed to load', sceneobjects[x], err);
      }
    }

    const vraiAgentObjects = sceneobjects.filter(o => o?.type === 'vraiAgent');
    if (vraiAgentObjects.length) {
      this.addVraiAgentChairsToScene(vraiAgentObjects);
      this._hydrateVraiChairScenariosFromLibrary();
    }
    const vapiUserCameraObjects = sceneobjects.filter(o => o?.type === 'vapiUserCamera');
    if (vapiUserCameraObjects.length) this.addVraiAgentCamerasToScene(vapiUserCameraObjects);
    const vapiTranscriptionObjects = sceneobjects.filter(o => o?.type === 'vapiTranscription');
    if (vapiTranscriptionObjects.length) this.addVraiAgentTranscriptionsToScene(vapiTranscriptionObjects);
    const vapiButtonObjects = sceneobjects.filter(o => o?.type === 'vapiButton');
    if (vapiButtonObjects.length) this.addVraiAgentButtonsToScene(vapiButtonObjects);
    const iframeElementObjects = sceneobjects.filter(o => o?.type === 'iframeElement');
    if (iframeElementObjects.length) this.addIframeElementsToScene(iframeElementObjects);
    const timerElementObjects = sceneobjects.filter(o => o?.type === 'timerElement');
    if (timerElementObjects.length) this.addTimerElementsToScene(timerElementObjects);
    const inputFieldGuessObjects = sceneobjects.filter(o => o?.type === 'inputFieldGuess');
    if (inputFieldGuessObjects.length) this.addInputFieldGuessElementsToScene(inputFieldGuessObjects);
    const inputFieldObjects = sceneobjects.filter(o => o?.type === 'inputField');
    if (inputFieldObjects.length) this.addInputFieldElementsToScene(inputFieldObjects);

    this._applyViewSceneRotation();
    this.needleOffset = this.editMode && this.currentScene?.hasOwnProperty('sceneRotationY') ? radians_to_degrees(this.currentScene.sceneRotationY) : 0; // needle offset has effect only in edit mode
    if (this.model.iAmInTour()) {
      this.addIsTourModeClassToIndicators();
    }
    // Ensure world matrices are up to date so first drag on loaded objects (e.g. VRVapiChairWithCSS3D) uses correct plane/offset
    this.interactionGroup.updateMatrixWorld(true);
    this._flushMissingObjectWarnings();
  }

  hideAllElements(condition = true) {
    this.objectsInScene.forEach(element => {
      if ((element.type === "webLink" || isVideoPlayerType(element.type)) && condition) {
        return;
      }
      if (element.type === "chessGame" && condition) {
        if (element.parent?.players && Object.keys(element.parent.players)) {
          return;
        }
      }
      if ((element.visible && (element.type === 'guestSeat' || element.type === 'screenStream')) && condition) {
        return;
      }
      if (!this.editMode && element.type === 'vrInvisibleAction') {
        if (element.material && !Array.isArray(element.material)) {
          element.material.opacity = 0;
          element.material.needsUpdate = true;
        }
        return;
      }
      if (!this.editMode && element.type === 'vrMusicObject') {
        element.visible = false;
        if (element.material && !Array.isArray(element.material)) {
          element.material.opacity = 0;
          element.material.needsUpdate = true;
        }
        return;
      }
      this.showHideAnimation({ element, scale: 0.001, opacity: 0 });
    });

    this.postits.forEach(element => {
      element.root.style.opacity = '0';
    });

    this.youtubeInScene.forEach(element => {
      this.showHideAnimation({ element, scale: 0, opacity: 0 });
    });
    this.vraiAgentsInScene.forEach(element => {
      this.showHideAnimation({ element, scale: 0, opacity: 0 });
    });
    this.vraiAgentChairs.forEach(chair => {
      if (chair.anchor) chair.anchor.visible = false;
    });
    this.vraiAgentCameras.forEach(cam => {
      if (cam.anchor) cam.anchor.visible = false;
    });
    this.vraiAgentTranscriptions.forEach(tr => {
      if (tr.anchor) tr.anchor.visible = false;
    });
    this.vraiAgentButtons.forEach(btn => {
      if (btn.anchor) btn.anchor.visible = false;
    });
    $(".video_element").length && gsap.to(".video_element", { duration: .5, opacity: 0 });
  };

  showAllElements(condition = true) {
    // In edit mode: show all. In view mode: only show elements where hideOnStart === false
    const hideOnStartActive = !this.editMode;
    this.objectsInScene.forEach(element => {
      if ((element.parent.dbConfig.type === "webLink" || isVideoPlayerType(element.parent.dbConfig.type)) && condition) {
        return;
      }
      if (hideOnStartActive && element.parent.dbConfig.hideOnStart) return;
      if (!this.editMode && element.type === 'vrInvisibleAction') {
        const hiddenBySceneAction = !!element.parent?.userData?.hiddenBySceneAction;
        if (hiddenBySceneAction) {
          element.visible = false;
          if (element.material && !Array.isArray(element.material)) {
            element.material.opacity = 0;
            element.material.needsUpdate = true;
          }
          return;
        }
        element.visible = true;
        if (element.material && !Array.isArray(element.material)) {
          element.material.opacity = 0;
          element.material.needsUpdate = true;
        }
        return;
      }
      if (!this.editMode && element.type === 'vrMusicObject') {
        element.visible = false;
        if (element.material && !Array.isArray(element.material)) {
          element.material.opacity = 0;
          element.material.needsUpdate = true;
        }
        return;
      }
      const scale = element.parent.dbConfig.size ?? element.parent.dbConfig.scale ?? 1;
      this.showHideAnimation({ element, scale, opacity: 1 });
    });
    this.youtubeInScene.forEach(element => {
      if (hideOnStartActive && element.dbConfig.hideOnStart) return;
      const scale = element.dbConfig.size ?? element.dbConfig.scale ?? 1;
      this.showHideAnimation({ element, scale, opacity: 1 });
    });
    this.vraiAgentsInScene.forEach(element => {
      if (hideOnStartActive && element.parent.dbConfig.hideOnStart) return;
      const scale = element.parent.dbConfig.size ?? element.parent.dbConfig.scale ?? 1;
      this.showHideAnimation({ element, scale, opacity: 1 });
    });
    this.vraiAgentChairs.forEach(chair => {
      if (chair.anchor) {
        const chairActive = chair.dbConfig?.components?.chair?.active !== false;
        const chairHideOnStart = !!(chair.dbConfig?.hideOnStart || chair.dbConfig?.components?.chair?.hideOnStart);
        const hidden = hideOnStartActive && chairHideOnStart;
        chair.anchor.visible = chairActive && !hidden;
      }
    });
    this.vraiAgentCameras.forEach(cam => {
      if (cam.anchor) {
        const chairId = cam.dbConfig?.vapiAgentId ?? cam.getDbConfig?.()?.vapiAgentId;
        const chair = chairId ? this.vraiAgentChairs.find(c => (c.getId?.() ?? c.id) === chairId) : null;
        const chairCfg = chair?.dbConfig || {};
        const chairActive = chairCfg?.components?.chair?.active !== false;
        const cameraActive = chairCfg?.components?.camera?.active !== false;
        const hiddenByHideOnStart = hideOnStartActive && (!!cam.dbConfig?.hideOnStart || !!chairCfg?.hideOnStart);
        // When not in edit mode, respect the owning chair's component "active" flags too.
        const hiddenByActive = hideOnStartActive && (!chairActive || !cameraActive);
        const hidden = hiddenByHideOnStart || hiddenByActive;
        cam.anchor.visible = !hidden;
      }
    });
    this.vraiAgentTranscriptions.forEach(tr => {
      if (tr.anchor) {
        const chairId = tr.dbConfig?.vapiAgentId ?? tr.getDbConfig?.()?.vapiAgentId;
        const chair = chairId ? this.vraiAgentChairs.find(c => (c.getId?.() ?? c.id) === chairId) : null;
        // Transcription is a child of vraiAgent chair: mirror chair visibility.
        // Fallback to previous hideOnStart logic if chair isn't resolved yet.
        if (chair?.anchor) {
          tr.anchor.visible = chair.anchor.visible !== false;
        } else {
          const hiddenByHideOnStart = hideOnStartActive && !!tr.dbConfig?.hideOnStart;
          tr.anchor.visible = !hiddenByHideOnStart;
        }
      }
    });
    this.vraiAgentButtons.forEach(btn => {
      if (btn.anchor) {
        const chairId = btn.dbConfig?.vapiAgentId ?? btn.getDbConfig?.()?.vapiAgentId;
        const chair = chairId ? this.vraiAgentChairs.find(c => (c.getId?.() ?? c.id) === chairId) : null;
        const hidden = hideOnStartActive && (!!btn.dbConfig?.hideOnStart || !!chair?.dbConfig?.hideOnStart);
        btn.anchor.visible = !hidden;
      }
    });

    $(".video_element").length && gsap.to(".video_element", { duration: .5, opacity: 1 });

    const tour = this.model.iAmInTour();
    if (tour) {
      $(".indicator").each((index, item) => {
        $(item).addClass("is-tour-mode")
      });
    } else {
      $(".indicator").each((index, item) => {
        $(item).removeClass("is-tour-mode")
      })
    }
    this.postits.forEach(element => {
      element.root.style.opacity = '1';
    });
  };

  showHideAnimation = ({ element, duration = .5, scale, opacity }) => {
    opacity && (element.material.opacity = 0);
    gsap.killTweensOf(element.scale);
    gsap.killTweensOf(element.material);
    // gsap.to(element.scale, { duration, x: scale, y: scale, z: scale });
    gsap.to(element.material, { opacity });
  }

  setWebRTCRoomID = () => {
    $("#roomId").val(this.model.currentScene.id);
  }

  _userEnterPublicStage() {
    this.setWebRTCRoomID();

    this.model.confirm($trans('join-public-stage'), () => {
      this.model.guestJoinedPublicStage = true;
      this.model.onNewUserJoinedPublicStage();
    }, { cancelBtnTxt: $trans('go-back-text'), dimmerClose: false, xBtn: false }, () => {
      if (!this.historyLastLocation) {
        history.back();
        history.back();
      } else {
        this.url.searchParams.set('loc', this.historyLastLocation);
        this.updateLocInsideURL(this.historyLastLocation);
        location.assign(this.url.href)
        this.historyLastLocation = null;
      }
    });
  }

  /**
   * Attach a 2D indicator DOM node for a scene object mesh.
   * @param {object} obj - VRPlaceObject / VRObject3D with .mesh
   * @param {object} options
   */
  _attachObjectIndicator(obj, {
    cls,
    icon,
    tooltip,
    dataLangKey,
    hideMesh = false,
    editModePreview = false,
    hideOnStart = false,
    isTourScreenShare = false,
    isChess = false,
  } = {}) {
    if (!obj?.mesh) return null;

    // Defensive de-duplication: scene/object rebuilds can occasionally run this path
    // more than once for the same mesh id. Ensure only one indicator node exists.
    $(`.indicator-${obj.mesh.id}`).remove();
    $(`.indicator[data-indicator='${obj.mesh.id}']`).remove();
    this._indicatorDomCache?.delete(`indicator-${obj.mesh.id}`);

    const indicator2d = indicator2D(obj.mesh.id, cls, icon, tooltip, dataLangKey);
    $(document.body).append(indicator2d);

    if (hideMesh) {
      obj.mesh.visible = false;
    }

    this.indicatorsArray = this.indicatorsArray.filter(
      (item) => String(item?.mesh?.id) !== String(obj.mesh?.id)
    );
    this.indicatorsArray.push({ mesh: obj.mesh, element: `indicator-${obj.mesh.id}` });

    const ind = $(`.indicator-${obj.mesh.id}`).last();
    if (editModePreview) {
      // Let edit-mode raycasts hit the invisible mesh underneath for select/drag.
      ind.addClass('edit-mode-preview');
    }

    if (isTourScreenShare) {
      this.elements2dTour.push(ind);
      ind.addClass('taken');
      ind.removeClass('visible');
    } else {
      this.elements2dnormal.push(ind);
      if (isChess) {
        obj.setIndicator?.(ind);
      }
      if (hideOnStart) {
        ind.addClass('hide-on-start');
      }
    }

    return ind;
  }

  /** Attach the default door indicator for a sceneChange with no custom image (edit mode). */
  _attachSceneChangeIndicator(obj) {
    return this._attachDefaultTypeIndicator(obj, 'sceneChange');
  }

  /** Attach the default link indicator for a webLink with no custom image (edit mode). */
  _attachWebLinkIndicator(obj) {
    return this._attachDefaultTypeIndicator(obj, 'webLink');
  }

  /** Attach the default play indicator for a videoPlayer with useIcon (edit mode). */
  _attachVideoPlayerIndicator(obj) {
    return this._attachDefaultTypeIndicator(obj, 'videoPlayer');
  }

  /** Attach the default info indicator for an infoElement (edit mode). */
  _attachInfoElementIndicator(obj) {
    return this._attachDefaultTypeIndicator(obj, 'infoElement');
  }

  /** Attach the default info indicator for an embeddedWebpage with no custom image (edit mode). */
  _attachEmbeddedWebpageIndicator(obj) {
    return this._attachDefaultTypeIndicator(obj, 'embeddedWebpage');
  }

  /** Attach the default gallery indicator for an imageGallery with useIcon (edit mode). */
  _attachImageGalleryIndicator(obj) {
    return this._attachDefaultTypeIndicator(obj, 'imageGallery');
  }

  _attachDefaultTypeIndicator(obj, type) {
    if (!obj?.mesh) return null;
    if (typeof obj.isIndicatorMode === 'function' ? !obj.isIndicatorMode() : obj.customIcon) return null;

    let cls = '';
    let icon = '';
    if (type === 'sceneChange') {
      const targetSceneId = obj.dbConfig?.goToSceneId;
      const targetScene = targetSceneId != null ? this.model.scenes[targetSceneId] : null;
      const locationWithPayment = targetScene?.locationWithPayment;
      const withPayment = locationWithPayment != null
        && Object.prototype.hasOwnProperty.call(locationWithPayment, 'state')
        && locationWithPayment.state;
      cls = withPayment ? 'scene-change-indicator withPayment' : 'scene-change-indicator';
      icon = obj.dbConfig?.customIcon || 'door_front';
    } else if (type === 'webLink') {
      cls = 'web-link-indicator';
      icon = 'link';
    } else if (type === 'videoPlayer') {
      cls = 'video-player-indicator';
      icon = 'play_circle';
    } else if (type === 'infoElement') {
      cls = 'info-indicator';
      icon = 'info';
    } else if (type === 'embeddedWebpage') {
      cls = 'embedded-webpage-indicator';
      icon = 'info';
    } else if (type === 'imageGallery') {
      cls = 'image-gallery-indicator';
      icon = 'photo_library';
    } else {
      return null;
    }

    const tooltip = obj.dbConfig?.tooltip || getTooltipByType(type);
    const dataLangKey = tooltip.replaceAll(' ', '-').toLowerCase();
    const finalTooltip = multiLanguagesController.languageObject.hasOwnProperty(dataLangKey)
      ? multiLanguagesController.languageObject[dataLangKey].text
      : tooltip;

    return this._attachObjectIndicator(obj, {
      cls,
      icon,
      tooltip: finalTooltip,
      dataLangKey,
      hideMesh: false,
      editModePreview: !!this.editMode,
    });
  }

  _removeObjectIndicator(mesh) {
    if (!mesh) return;
    const elementKey = `indicator-${mesh.id}`;
    $(`.indicator-${mesh.id}`).remove();
    $(`.indicator[data-indicator='${mesh.id}']`).remove();
    this._indicatorDomCache?.delete(elementKey);
    this.indicatorsArray = this.indicatorsArray.filter(
      (item) => String(item?.mesh?.id) !== String(mesh.id)
    );
  }

  getIndicatorFromMeshId = (id) => {
    return this.indicatorsArray.find(item => item?.mesh?.parent?.dbConfig?.id === id);
  }

  _buildWorld(texture) {
    if (!this.currentScene) {
      this._notifyMissingScene(this.currentScene?.id);
      return;
    }
    this.setPublicStageStatus();
    this._updateSphereTexture(texture);
    // console.log('room index: ', this.currentSceneIndex);
    $(".slidecontainer").removeClass('visible');


    if (!this.editMode && this.model.publicStage) {
      this._userEnterPublicStage();
    }

    this.updateLocInsideURL();

    this._applyViewSceneRotation();
    this.controls.reset(); // needed for view mode

    if (!this.editMode) {
      this._consumeEditModeRotUrlParam();
    }

    if (this.editMode) {
      this.needleOffset = this.currentScene.hasOwnProperty('sceneRotationY') ? radians_to_degrees(this.currentScene.sceneRotationY) : 0;
      const rotParam = parseFloat(this.urlParams.get('rot'));
      this.pivot.rotation.y = Number.isFinite(rotParam) ? rotParam : 0;
      this._applyEditModeSphereTileStreaming();
    }

    this._removeElementsFromScene();
    this._addElementsToScene(this.currentScene.objects || []);
    // Edit mode: always show all elements (hideOnStart is ignored). View mode: show when model.showElements
    if (this.editMode || this.model.showElements) {
      this.showAllElements(false);
    }
    this.model.onNewSceneInitialised();
    if (this._pageMediaMuted) {
      this._schedulePageMediaMuteReapply?.();
    }
  }

  _getCachedTexture(targetID) {
    return this.visitedRoomsTextures.find(room => room.id === targetID)?.texture || null;
  }

  _removeElementsFromScene() {
    this._stopSceneLoopedSounds();
    this.interactionGroup.clear();
    this.youtubeVideos.clear();
    this.youtubeInScene = [];
    this.vraiAgentsInScene = [];
    this.objectsInScene = [];
    $(".youtube_poster").remove();
    $(".iframe_poster_wrapper").remove();
    $(".vrai_agent_poster_wrapper").remove();
    $(".css3d_test_wrapper").remove();
    $(".vapi_camera2_wrapper").remove();
    $(".vapi_transcription2_wrapper").remove();
    $(".vapi_button2_wrapper").remove();
    $(".vapi_transcription2d-indicator").remove();
    $(".vapi-button2d-indicator").remove();
    this.removePostitsFromScene();
    this.removeVraiAgentChairsFromScene();
    this.removeVraiAgentCamerasFromScene();
    this.removeVraiAgentTranscriptionsFromScene();
    this.removeVraiAgentButtonsFromScene();
    this.removeIframeElementsFromScene();
    this.removeTimerElementsFromScene();
    this.removeInputFieldGuessElementsFromScene();
    this.removeInputFieldElementsFromScene();
  }

  /**
   * Resolve a click on a CSS3D-rendered element to the corresponding scene object.
   * Components like VRVapiChairWithCSS3D use zero-size meshes so raycasting never hits them.
   * @param {HTMLElement} element - Clicked element or one inside [data-css3d-interactive] with data-id
   * @returns {{ object: Object } | null} - Synthetic intersect { object } or null
   */
  getSceneObjectFromCss3dClick(element) {
    if (!element) return null;
    const wrapper = element.closest && element.closest('[data-css3d-interactive][data-id]');
    const el = wrapper || (element.getAttribute && element.getAttribute('data-id') ? element : null);
    if (!el) return null;
    const dataId = el.getAttribute('data-id');
    if (!dataId) return null;
    const vraiMatch = dataId.match(/^vrai_agent_(.+)$/);
    if (vraiMatch && this.vraiAgentChairs && this.vraiAgentChairs.length) {
      const chair = this.vraiAgentChairs.find(c => c.id != null && String(c.id) === String(vraiMatch[1]));
      return chair ? { object: chair } : null;
    }
    const vapiCameraMatch = dataId.match(/^vapi_camera2_(.+)$/);
    if (vapiCameraMatch && this.vraiAgentCameras && this.vraiAgentCameras.length) {
      const cam = this.vraiAgentCameras.find(c => (c.id || c.getId?.()) != null && String(c.id || c.getId?.()) === String(vapiCameraMatch[1]));
      return cam ? { object: cam } : null;
    }
    const vapiTranscriptionMatch = dataId.match(/^vapi_transcription2_(.+)$/);
    if (vapiTranscriptionMatch && this.vraiAgentTranscriptions && this.vraiAgentTranscriptions.length) {
      const tr = this.vraiAgentTranscriptions.find(t => (t.id || t.getId?.()) != null && String(t.id || t.getId?.()) === String(vapiTranscriptionMatch[1]));
      return tr ? { object: tr } : null;
    }
    const vapiButtonMatch = dataId.match(/^vapi_button2_(.+)$/);
    if (vapiButtonMatch && this.vraiAgentButtons && this.vraiAgentButtons.length) {
      const btn = this.vraiAgentButtons.find(b => (b.id || b.getId?.()) != null && String(b.id || b.getId?.()) === String(vapiButtonMatch[1]));
      return btn ? { object: btn } : null;
    }
    const iframeElementMatch = dataId.match(/^iframe_element_(.+)$/);
    if (iframeElementMatch && this.iframeElementsInScene && this.iframeElementsInScene.length) {
      const iframeEl = this.iframeElementsInScene.find((item) => item.id != null && String(item.id) === String(iframeElementMatch[1]));
      return iframeEl ? { object: iframeEl } : null;
    }
    const timerElementMatch = dataId.match(/^timer_element_(.+)$/);
    if (timerElementMatch && this.timerElementsInScene && this.timerElementsInScene.length) {
      const timerEl = this.timerElementsInScene.find((item) => item.id != null && String(item.id) === String(timerElementMatch[1]));
      return timerEl ? { object: timerEl } : null;
    }
    const inputFieldGuessMatch = dataId.match(/^input_field_guess_(.+)$/);
    if (inputFieldGuessMatch && this.inputFieldGuessElementsInScene && this.inputFieldGuessElementsInScene.length) {
      const guessEl = this.inputFieldGuessElementsInScene.find((item) => item.id != null && String(item.id) === String(inputFieldGuessMatch[1]));
      return guessEl ? { object: guessEl } : null;
    }
    const inputFieldMatch = dataId.match(/^input_field_(.+)$/);
    if (inputFieldMatch && this.inputFieldElementsInScene && this.inputFieldElementsInScene.length) {
      const inputEl = this.inputFieldElementsInScene.find((item) => item.id != null && String(item.id) === String(inputFieldMatch[1]));
      return inputEl ? { object: inputEl } : null;
    }
    return null;
  }

  getAllowedCss3dInteractiveTarget(target) {
    const interactiveEl = target?.closest?.('[data-css3d-interactive]');
    if (!interactiveEl) return null;
    const clickTargetSelector = interactiveEl.getAttribute?.('data-css3d-click-target');
    if (!clickTargetSelector) return interactiveEl;
    return target?.closest?.(clickTargetSelector) ? interactiveEl : null;
  }

  _ray_tracing(e, objects) {
    const uv = this._rayTracingVector;
    const rect = webglCanvas.getBoundingClientRect();
    uv.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
    uv.y = 1 - ((e.clientY - rect.top) / rect.height) * 2;
    this.raycaster.setFromCamera(uv, this.camera);
    return this.raycaster.intersectObjects(objects);
  }

  /** Raycast from the center of the WebGL viewport (camera look direction), not the mouse. */
  _raycastFromCameraCenter(objects) {
    const uv = this._rayTracingVector;
    uv.x = 0;
    uv.y = 0;
    this.raycaster.setFromCamera(uv, this.camera);
    return this.raycaster.intersectObjects(objects);
  }

  /**
   * rot is passed when switching edit → view to preserve camera yaw.
   * Bake it into the camera / orbit rig and remove from the URL so it does not
   * leave pivot.rotation.y non-zero (that breaks OrbitControls after animateCameraLookAt).
   */
  _consumeEditModeRotUrlParam() {
    const rotParam = parseFloat(this.urlParams.get('rot'));
    if (!Number.isFinite(rotParam)) {
      return;
    }

    if (Math.abs(rotParam) > 1e-10) {
      this.camera.rotateOnWorldAxis(new Vector3(0, 1, 0), rotParam);
      this.pivot.rotation.y = 0;
      this.pivotLastRotation = 0;
    }

    this.controls.update();
    this.controls.saveState();

    if (!this.url.searchParams.has('rot')) {
      return;
    }

    this.url.searchParams.delete('rot');
    this.urlParams.delete('rot');
    if (this.model?.url?.searchParams?.has('rot')) {
      this.model.url.searchParams.delete('rot');
    }
    window.history.replaceState('', '', this.url.pathname + this.url.search);
  }

  /**
   * North for objects + the wrapper pano (roomGroup). 0 is valid.
   * Do not inherit live roomGroup rotation (that is the previous scene during sceneChange).
   * Do not rotate VRSphere here — tiles are not parented to roomGroup and already use
   * this scene's sceneRotationY at construction / stopSceneChanged.
   */
  _getEffectiveSceneRotationY(scene = this.currentScene) {
    if (!scene) {
      return 0;
    }
    const sceneId = scene.id;
    const direct = Number(scene.sceneRotationY);
    if (Number.isFinite(direct)) {
      return direct;
    }
    const fromModel = sceneId != null ? Number(this.model?.scenes?.[sceneId]?.sceneRotationY) : NaN;
    if (Number.isFinite(fromModel)) {
      return fromModel;
    }
    const fromNorth = sceneId != null ? Number(this.model?._sceneNorthById?.[sceneId]) : NaN;
    if (Number.isFinite(fromNorth)) {
      return fromNorth;
    }
    return 0;
  }

  _applyViewSceneRotation(scene = this.currentScene) {
    if (this.roomGroup) {
      gsap.killTweensOf(this.roomGroup.rotation);
      gsap.killTweensOf(this.roomGroup.position);
      this.roomGroup.position.set(0, 0, 0);
    }
    this.roomGroup.rotation.y = this.editMode ? 0 : this._getEffectiveSceneRotationY(scene);
  }

  _getLookAtTargetPosition(parent) {
    const targetObject = parent?.mesh || parent?.anchor;
    if (!targetObject) {
      return null;
    }
    const sceneRotY = this._getEffectiveSceneRotationY();
    this.roomGroup.rotation.y = sceneRotY;
    this.roomGroup.updateMatrixWorld(true);

    const targetPosition = new Vector3();
    if (!this.editMode) {
      targetObject.getWorldPosition(targetPosition);
    } else {
      const objId = parent.getId?.() ?? parent.unique_id ?? parent.dbConfig?.id;
      const sceneObj = objId && this.currentScene?.objects?.find((o) => String(o.id) === String(objId));
      if (sceneObj && [sceneObj.x, sceneObj.y, sceneObj.z].every((v) => Number.isFinite(Number(v)))) {
        targetPosition.set(Number(sceneObj.x), Number(sceneObj.y), Number(sceneObj.z || 0));
        this.roomGroup.localToWorld(targetPosition);
      } else {
        targetObject.getWorldPosition(targetPosition);
      }
    }

    if (!Number.isFinite(targetPosition.x) || !Number.isFinite(targetPosition.y) || !Number.isFinite(targetPosition.z)) {
      return null;
    }
    targetPosition.negate();
    return targetPosition;
  }

  cameraPreservedAngle = (substract) => { // INSTEAD OF SUBSTRACT PROP WE CAN USE ALSO !this.editMode, BUT THEN WE WILL NOT HAVE ABSOLUTE CONTROL OVER THIS METHODE
    const cameraRotation = this.controls.getAzimuthalAngle() < 0 ? Math.PI + Math.PI + this.controls.getAzimuthalAngle() : this.controls.getAzimuthalAngle();
    const normalizedPivot = normaliseAngle(0, radians_to_degrees(this.pivot.rotation.y));
    const pivotRotation = this.pivot.rotation.y < 0 ? (360 - normalizedPivot) * -1 : normalizedPivot;
    const camPlusPivot = cameraRotation + degrees_to_radians(pivotRotation)
    const cameraPreservedAngle = substract ? camPlusPivot - this.currentScene.sceneRotationY : camPlusPivot + this.currentScene.sceneRotationY;
    return cameraPreservedAngle;
  }

  get2DSpaceCoordinates = (mesh, viewportWidth = null, viewportHeight = null) => {
    const worldPosition = new Vector3();
    mesh.getWorldPosition(worldPosition);
    const screenPosition = worldPosition.clone();
    screenPosition.project(this.camera);

    this.raycaster.setFromCamera(screenPosition, this.camera);

    const intersects = this.raycaster.intersectObject(mesh);
    const w = viewportWidth ?? this.sizes.width;
    const h = viewportHeight ?? this.sizes.height;
    const translateX = screenPosition.x * w * 0.5;
    const translateY = -screenPosition.y * h * 0.5;

    // Scale overlay with distance so it fits when zoom changes (closer = larger, farther = smaller)
    const camPos = this.camera.getWorldPosition(new Vector3());
    const distance = worldPosition.distanceTo(camPos);
    const refDistance = 500;
    const scale = Math.max(0.3, Math.min(2, refDistance / distance));

    return { intersects: intersects.length > 0, translateX, translateY, scale }
  }

  getSceneById = (id) => {
    let currentSceneIndex = 0;
    let currentScene = this.scenes[0];  // todo: home location will no longer be first scene in the array, it will be fetched based on it's id and the id will be set as a prop (home or entryPoint) inside worldData after ownerId
    let found = false;

    if (id !== null) {
      for (let x = 0; x < this.scenes.length; x++) {
        if (this.scenes[x].id === id) {
          currentSceneIndex = x;
          currentScene = this.scenes[x];
          found = true;
          break;
        }
      }
    } else {
      found = true;
    }

    !found && console.error(`Scene with id: ${id} does not exist, first scene has been returned`);

    this.updateLocInsideURL(currentScene.id);

    return { currentScene, currentSceneIndex }
  }

  updateLocInsideURL = (id = null) => {
    const urlParams = new URLSearchParams(window.location.search);
    const currentLocUrl = urlParams.get('loc') || '';
    const newLocId = id || this.currentScene.id;

    if (currentLocUrl !== newLocId) {
      this.url.searchParams.set('loc', newLocId);
      window.history.pushState("", "", this.url.pathname + this.url.search);
    }
  }

  setPublicStageStatus = (currentScene = this.currentScene) => {
    let publicStage = false;
    if (currentScene.hasOwnProperty('publicStage')) {
      publicStage = currentScene.publicStage;
    }
    this.model.publicStage = publicStage;
    // console.log('currentScene ', currentScene);
    // console.log('this.model.publicStage ',this.model.publicStage);
    if (!this.editMode && !this.model.publicStage && this.model.iPlayPublicStream) {
      this.model.onUserLeftPublicStage(this.model.config.userId);
    }

  }

  isPaidLocation = (scene) => {
    if (!scene) return false;
    return scene.hasOwnProperty("locationWithPayment") ? scene.locationWithPayment.hasOwnProperty("state") ? scene.locationWithPayment.state : false : false;
  }

  validateTicketIfPaidLocation = async (location = this.currentScene) => {

    if (this.isPaidLocation(location)) {

      if (this.model.userIsContributor || this.model.userIsOwner) {
        return new Promise(function (resolve) { resolve(true); });
      }

      const config = {
        method: 'post',
        url: this.model.config.validateLocationTicketURL,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
        },
        data: { locationId: location.id, userId: this.model.config.userId }
      };

      this.model.showLoading()

      try {
        const response = await axios(config);
        this.model.hideLoading()
        if (response.status !== 200) {
          console.error(`${response.status} - ${response.statusText}`);
          return new Promise(function (resolve) { resolve(false); });
        }

        if (!response.data.valid) {
          return new Promise(function (resolve) { resolve(false); });
        }

        return new Promise(function (resolve) { resolve(response.data.valid); });
      } catch (error) {
        this.model.hideLoading()
        console.error(error);
        return new Promise(function (resolve) { resolve(false); });
      }
    } else {
      return new Promise(function (resolve) { resolve(true); });
    }

  }
  countItemsInScene = (type) => {
    let count = 0;
    (this.currentScene?.objects || []).forEach(element => {
      if (element.type === type) {
        count++;
      }
    });
    return count;
  }
  destroy() {
    // ... existing cleanup code ...

    if (this._iframeMouseHandler) {
      window.removeEventListener('message', this._iframeMouseHandler);
      this._iframeMouseHandler = null;
    }

    // Clean up auto-rotate controller
    if (this.autoRotateController) {
      this.autoRotateController.destroy();
      this.autoRotateController = null;
    }
  }

  updateCompass() {
    if (!this.lastCompassUpdate || Date.now() - this.lastCompassUpdate > 16) { // ~60fps
      const normalizedAngle = normaliseAngle(
        radians_to_degrees(this.pivot.rotation.y),
        radians_to_degrees(this.controls.getAzimuthalAngle())
      );
      this.$compassNeedle.attr('data-currentRotation', normalizedAngle ? Math.abs(360 - normalizedAngle) : 0);
      const needleAngle = normalizedAngle + this.needleOffset;
      this.$compassNeedle.css({ transform: `translate(-50%, -50%) rotate(${needleAngle}deg)` });
      this.lastCompassUpdate = Date.now();
    }
  }

  debouncedResize = () => {
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.onWindowResize();
    }, 250);
  }
  addPostitsToScene(postits) {
    if (this.model.sceneData.disablePostits === 1 || this.model.sceneData.disablePostits) {
      return;
    }
    postits.forEach(postit => {
      if (postit.scene_id !== this.model.currentScene.id) {
        return;
      }
      const data = {
        id: postit.id,
        creator: postit.creator,
        ...JSON.parse(postit.data)
      }
      const postitElement = new Postit({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        ...data
      });
      this.scene.add(postitElement.object);
      this.postits.push(postitElement);
    });
  }
  removePostitsFromScene() {
    this.postits.forEach(postit => {
      try { postit.destroy && postit.destroy(); } catch (e) { }
      this.scene.remove(postit.object);
    });
    this.postits = [];
  }

  _applyChairScenarioToChair(chair, scenario) {
    const text = (scenario != null ? String(scenario) : '').trim();
    if (!chair || !text) return;
    chair.setDbConfig?.({ chairScenario: text });
    const chairId = chair.getId?.() ?? chair.id;
    const sceneObj = this.currentScene?.objects?.find((o) => o.type === 'vraiAgent' && String(o.id) === String(chairId));
    if (sceneObj) sceneObj.chairScenario = text;
    const cfg = chair.getDbConfig?.() || chair.dbConfig || {};
    const inst = chair._vapiChairInstance;
    if (inst?.updateChairLabels) inst.updateChairLabels(cfg.chairName, text);
  }

  /**
   * Library agents store scenario text in agent_config; older placed chairs may lack chairScenario on the scene object.
   */
  _hydrateVraiChairScenariosFromLibrary() {
    const listFn = this.model?.worldFetcher?.listVapiAgents;
    const worldId = this.worldID;
    if (!listFn || !worldId) return;

    const chairsNeedingScenario = (this.vraiAgentChairs || []).filter((chair) => {
      const cfg = chair.getDbConfig?.() || chair.dbConfig || {};
      const scenario = (cfg.chairScenario != null ? String(cfg.chairScenario) : '').trim();
      return !scenario;
    });
    if (!chairsNeedingScenario.length) return;

    listFn(
      worldId,
      (res) => {
        const agents = res?.agents || [];
        let updated = false;
        chairsNeedingScenario.forEach((chair) => {
          const cfg = chair.getDbConfig?.() || chair.dbConfig || {};
          const lib = findLibraryAgentForChair(agents, cfg);
          if (!lib) return;
          const scenario = (buildFullAgentConfigFromLibrary(lib).chairScenario || '').trim();
          if (!scenario) return;
          this._applyChairScenarioToChair(chair, scenario);
          updated = true;
        });
        if (updated && this.editMode && typeof this.updateDB === 'function') {
          this.scenes[this.currentSceneIndex] = this.currentScene;
          this.updateDB();
        }
      },
      () => { }
    );
  }

  _addSceneComponentSafely(kind, data, createFn) {
    try {
      return createFn();
    } catch (err) {
      this._reportMissingObject(`${kind} failed to load`, { ...data, type: data?.type || kind }, err);
      return null;
    }
  }

  addVraiAgentChairsToScene(vraiAgentObjects) {
    if (!vraiAgentObjects || !vraiAgentObjects.length) return;
    vraiAgentObjects.forEach(obj => {
      const chairElement = this._addSceneComponentSafely('vraiAgent', obj, () => new VRVapiChairWithCSS3D({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position: { x: obj.x ?? 0, y: obj.y ?? 0, z: obj.z ?? -600 },
        id: obj.id,
        dbConfig: obj,
        editMode: this.editMode,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || webglCanvas
      }));
      if (!chairElement) return;
      const group = this.editMode ? this.interactionGroup : this.roomGroup;
      // "hideOnStart" must mean: don't add the CSS3D object to the scene graph yet.
      // It will be added back by the external "show" action when needed.
      const chairActive = obj?.components?.chair?.active !== false;
      const hideOnStart = !!(obj?.hideOnStart || obj?.components?.chair?.hideOnStart);
      const shouldAdd = this.editMode || (chairActive && !hideOnStart);
      if (shouldAdd) group.add(chairElement.anchor);
      // VRVapiChairWithCSS3D now renders as CSS3DObject in scene (no external indicator layer append).
      this.vraiAgentChairs.push(chairElement);
    });
  }

  addVraiAgentTranscriptionsToScene(vapiTranscriptionObjects) {
    if (!vapiTranscriptionObjects || !vapiTranscriptionObjects.length) return;
    vapiTranscriptionObjects.forEach(obj => {
      const trElement = this._addSceneComponentSafely('vapiTranscription', obj, () => new VRVapiTranscriptionWithCSS3D({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position: { x: obj.x ?? 0, y: obj.y ?? 0, z: obj.z ?? -900 },
        id: obj.id,
        dbConfig: obj,
        editMode: this.editMode,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || webglCanvas
      }));
      if (!trElement) return;
      const group = this.editMode ? this.interactionGroup : this.roomGroup;
      const chairId = obj?.vapiAgentId ?? null;
      const chair = chairId ? this.vraiAgentChairs.find(c => String(c.getId?.() ?? c.id) === String(chairId)) : null;
      const chairCfg = chair?.dbConfig || {};
      const chairActive = chairCfg?.components?.chair?.active !== false;
      const transcriptionActive = chairCfg?.components?.transcription?.active !== false;
      const chairHideOnStart = !!(chairCfg?.hideOnStart || chairCfg?.components?.chair?.hideOnStart);
      const ownHideOnStart = !!obj?.hideOnStart;
      const shouldAdd = this.editMode || (chairActive && transcriptionActive && !(chairHideOnStart || ownHideOnStart));
      if (shouldAdd) group.add(trElement.anchor);
      // VRVapiTranscriptionWithCSS3D now renders as CSS3DObject in scene.
      this.vraiAgentTranscriptions.push(trElement);
    });
  }

  addVraiAgentButtonsToScene(vapiButtonObjects) {
    if (!vapiButtonObjects || !vapiButtonObjects.length) return;
    vapiButtonObjects.forEach(obj => {
      const btnElement = this._addSceneComponentSafely('vapiButton', obj, () => new VRVapiButtonWithCSS3D({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position: { x: obj.x ?? 0, y: obj.y ?? 0, z: obj.z ?? -600 },
        id: obj.id,
        dbConfig: obj,
        editMode: this.editMode,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || webglCanvas
      }));
      if (!btnElement) return;
      const group = this.editMode ? this.interactionGroup : this.roomGroup;
      const chairId = obj?.vapiAgentId ?? null;
      const chair = chairId ? this.vraiAgentChairs.find(c => String(c.getId?.() ?? c.id) === String(chairId)) : null;
      const chairCfg = chair?.dbConfig || {};
      const chairActive = chairCfg?.components?.chair?.active !== false;
      const chairHideOnStart = !!(chairCfg?.hideOnStart || chairCfg?.components?.chair?.hideOnStart);
      const ownHideOnStart = !!obj?.hideOnStart;
      const shouldAdd = this.editMode || (chairActive && !(chairHideOnStart || ownHideOnStart));
      if (shouldAdd) group.add(btnElement.anchor);
      const layer = document.getElementById('vapi-buttons-layer');
      if (btnElement.dom) {
        (layer || document.body).appendChild(btnElement.dom);
      }
      this.indicatorsArray.push({ mesh: btnElement.anchor, element: btnElement.elementClass });
      this.vraiAgentButtons.push(btnElement);
    });
  }

  addVraiAgentCamerasToScene(vapiUserCameraObjects) {
    if (!vapiUserCameraObjects || !vapiUserCameraObjects.length) return;
    vapiUserCameraObjects.forEach(obj => {
      const camElement = this._addSceneComponentSafely('vapiUserCamera', obj, () => new VRVapiCameraWithCSS3D({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position: { x: obj.x ?? 0, y: obj.y ?? 0, z: obj.z ?? -600 },
        id: obj.id,
        dbConfig: obj,
        editMode: this.editMode,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || webglCanvas
      }));
      if (!camElement) return;
      const group = this.editMode ? this.interactionGroup : this.roomGroup;
      const chairId = obj?.vapiAgentId ?? null;
      const chair = chairId ? this.vraiAgentChairs.find(c => String(c.getId?.() ?? c.id) === String(chairId)) : null;
      const chairCfg = chair?.dbConfig || {};
      const chairActive = chairCfg?.components?.chair?.active !== false;
      const cameraActive = chairCfg?.components?.camera?.active !== false;
      const chairHideOnStart = !!(chairCfg?.hideOnStart || chairCfg?.components?.chair?.hideOnStart);
      const ownHideOnStart = !!obj?.hideOnStart;
      const shouldAdd = this.editMode || (chairActive && cameraActive && !(chairHideOnStart || ownHideOnStart));
      if (shouldAdd) group.add(camElement.anchor);
      // VRVapiCameraWithCSS3D now renders as CSS3DObject in scene.
      this.vraiAgentCameras.push(camElement);
    });
  }

  removeVraiAgentChairsFromScene() {
    this.vraiAgentChairs.forEach(chair => {
      this._indicatorDomCache?.delete(chair.elementClass);
      this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== chair.anchor);
      try { chair.destroy && chair.destroy(); } catch (e) { }
      if (chair.anchor?.parent) chair.anchor.parent.remove(chair.anchor);
    });
    this.vraiAgentChairs = [];
  }

  removeVraiAgentCamerasFromScene() {
    this.vraiAgentCameras.forEach(cam => {
      this._indicatorDomCache?.delete(cam.elementClass);
      this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== cam.anchor);
      try { cam.destroy && cam.destroy(); } catch (e) { }
      if (cam.anchor && cam.anchor.parent) cam.anchor.parent.remove(cam.anchor);
    });
    this.vraiAgentCameras = [];
  }

  removeVraiAgentTranscriptionsFromScene() {
    this.vraiAgentTranscriptions.forEach(tr => {
      this._indicatorDomCache?.delete(tr.elementClass);
      this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== tr.anchor);
      try { tr.destroy && tr.destroy(); } catch (e) { }
      if (tr.anchor && tr.anchor.parent) tr.anchor.parent.remove(tr.anchor);
    });
    this.vraiAgentTranscriptions = [];
  }

  removeVraiAgentButtonsFromScene() {
    this.vraiAgentButtons.forEach(btn => {
      this._indicatorDomCache?.delete(btn.elementClass);
      this.indicatorsArray = this.indicatorsArray.filter(ind => ind.mesh !== btn.anchor);
      try { btn.destroy && btn.destroy(); } catch (e) { }
      if (btn.anchor?.parent) btn.anchor.parent.remove(btn.anchor);
    });
    this.vraiAgentButtons = [];
  }

  addIframeElementsToScene(iframeElementObjects) {
    if (!iframeElementObjects || !iframeElementObjects.length) return;
    iframeElementObjects.forEach((obj) => {
      const element = this._addSceneComponentSafely('iframeElement', obj, () => new VRIframeElement({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position: { x: obj.x ?? 0, y: obj.y ?? 0, z: obj.z ?? -540 },
        id: obj.id,
        dbConfig: obj,
        editMode: this.editMode,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || webglCanvas
      }));
      if (!element) return;
      const group = this.editMode ? this.interactionGroup : this.roomGroup;
      const shouldAdd = this.editMode || !obj?.hideOnStart;
      if (shouldAdd) group.add(element.anchor);
      if (obj.distance != null) element.setDistance(obj.distance);
      this.iframeElementsInScene.push(element);
      if (this.editMode && element.mesh) {
        this.objectsInScene.push(element.mesh);
      }
    });
  }

  removeIframeElementsFromScene() {
    this.iframeElementsInScene.forEach((item) => {
      try { item.destroy && item.destroy(); } catch (e) { }
      if (item.anchor?.parent) item.anchor.parent.remove(item.anchor);
    });
    this.iframeElementsInScene = [];
  }

  addTimerElementsToScene(timerElementObjects) {
    if (!timerElementObjects || !timerElementObjects.length) return;
    timerElementObjects.forEach((obj) => {
      const element = this._addSceneComponentSafely('timerElement', obj, () => new VRTimerElement({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position: { x: obj.x ?? 0, y: obj.y ?? 0, z: obj.z ?? -540 },
        id: obj.id,
        dbConfig: obj,
        editMode: this.editMode,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || webglCanvas
      }));
      if (!element) return;
      const group = this.editMode ? this.interactionGroup : this.roomGroup;
      // Always track the instance for start/stop/reset; only mount CSS3D in edit mode
      // (view mode keeps the timer logic-only and never visible).
      if (this.editMode) group.add(element.anchor);
      if (obj.distance != null) element.setDistance(obj.distance);
      this.timerElementsInScene.push(element);
      if (this.editMode && element.mesh) {
        this.objectsInScene.push(element.mesh);
      }
    });
  }

  removeTimerElementsFromScene() {
    this.timerElementsInScene.forEach((item) => {
      try { item.destroy && item.destroy(); } catch (e) { }
      if (item.anchor?.parent) item.anchor.parent.remove(item.anchor);
    });
    this.timerElementsInScene = [];
  }

  addInputFieldGuessElementsToScene(inputFieldGuessObjects) {
    if (!inputFieldGuessObjects || !inputFieldGuessObjects.length) return;
    inputFieldGuessObjects.forEach((obj) => {
      const element = this._addSceneComponentSafely('inputFieldGuess', obj, () => new VRInputFieldGuess({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position: { x: obj.x ?? 0, y: obj.y ?? 0, z: obj.z ?? -540 },
        id: obj.id,
        dbConfig: obj,
        editMode: this.editMode,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || webglCanvas
      }));
      if (!element) return;
      if (this.editMode) {
        this.interactionGroup.add(element.anchor);
        if (obj.distance != null) element.setDistance(obj.distance);
        if (element.mesh) this.objectsInScene.push(element.mesh);
      } else {
        // View mode: keep instance for open/close actions only — no HTML, no mesh, no indicator.
        element._detachViewVisuals?.();
      }
      this.inputFieldGuessElementsInScene.push(element);
    });
  }

  removeInputFieldGuessElementsFromScene() {
    this.inputFieldGuessElementsInScene.forEach((item) => {
      try { item.destroy && item.destroy(); } catch (e) { }
      if (item.anchor?.parent) item.anchor.parent.remove(item.anchor);
    });
    this.inputFieldGuessElementsInScene = [];
  }

  addInputFieldElementsToScene(inputFieldObjects) {
    if (!inputFieldObjects || !inputFieldObjects.length) return;
    inputFieldObjects.forEach((obj) => {
      const element = this._addSceneComponentSafely('inputField', obj, () => new VRInputField({
        model: this.model,
        camera: this.camera,
        controls: this.controls,
        raycaster: this.raycaster,
        position: { x: obj.x ?? 0, y: obj.y ?? 0, z: obj.z ?? -540 },
        id: obj.id,
        dbConfig: obj,
        editMode: this.editMode,
        sizes: this.sizes,
        viewportElement: this.webglRenderer?.domElement || webglCanvas
      }));
      if (!element) return;
      if (this.editMode) {
        this.interactionGroup.add(element.anchor);
        if (obj.distance != null) element.setDistance(obj.distance);
        if (element.mesh) this.objectsInScene.push(element.mesh);
      } else {
        element._detachViewVisuals?.();
      }
      this.inputFieldElementsInScene.push(element);
    });
  }

  removeInputFieldElementsFromScene() {
    this.inputFieldElementsInScene.forEach((item) => {
      try { item.destroy && item.destroy(); } catch (e) { }
      if (item.anchor?.parent) item.anchor.parent.remove(item.anchor);
    });
    this.inputFieldElementsInScene = [];
  }

  addIsTourModeClassToIndicators() {
    $(".indicator").each((index, item) => {
      $(item).addClass("is-tour-mode")
    });
    $(".tour-screen-share-indicator").each((index, item) => {
      $(item).removeClass("taken")
    });
  }
  removeIsTourModeClassFromIndicators() {
    $(".indicator").each((index, item) => {
      $(item).removeClass("is-tour-mode")
    });
  }
}

export { Scene3D }
